// icons.js (or icons.ts)

export const icons = {
    SortDownSmall: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M6.414,15.586H17.586a1,1,0,0,0,.707-1.707L12.707,8.293a1,1,0,0,0-1.414,0L5.707,13.879A1,1,0,0,0,6.414,15.586Z",
                transform: "translate(0 24) scale(1 -1)",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    SortUpSmall: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M6.414,15.586H17.586a1,1,0,0,0,.707-1.707L12.707,8.293a1,1,0,0,0-1.414,0L5.707,13.879A1,1,0,0,0,6.414,15.586Z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    SortUp: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M11.744,18c-.757,0-1.48-.323-1.985-.886L3.328,10.587c-.602-.657-.747-1.535-.402-2.317,.345-.783,1.09-1.27,1.945-1.27h13.745c.854,0,1.6,.486,1.944,1.269s.2,1.66-.376,2.291l-6.487,6.589c-.474,.528-1.197,.852-1.953,.852Z",
                transform: "translate(0 24) scale(1 -1)",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    SortDown: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M11.744,18c-.757,0-1.48-.323-1.985-.886L3.328,10.587c-.602-.657-.747-1.535-.402-2.317,.345-.783,1.09-1.27,1.945-1.27h13.745c.854,0,1.6,.486,1.944,1.269s.2,1.66-.376,2.291l-6.487,6.589c-.474,.528-1.197,.852-1.953,.852Z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    SortUpDown: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M18.873,11.021H5.127a2.126,2.126,0,0,1-1.568-3.56L10.046.872a2.669,2.669,0,0,1,3.939.034l6.431,6.528a2.126,2.126,0,0,1-1.543,3.587ZM12,24.011a2.667,2.667,0,0,1-1.985-.887L3.584,16.6a2.125,2.125,0,0,1,1.543-3.586H18.873a2.125,2.125,0,0,1,1.568,3.558l-6.487,6.589A2.641,2.641,0,0,1,12,24.011Z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    Up: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M10,24c-1.66,0-3-1.34-3-3V13h-1.92c-1.17,0-2.29-.62-2.8-1.67-.57-1.18-.34-2.51,.57-3.43L9.17,1.18c1.57-1.57,4.09-1.57,5.64-.02,0,0,6.37,6.77,6.37,6.77,.85,.84,1.1,2.09,.63,3.22-.47,1.13-1.52,1.84-2.74,1.85h-2.06v8c0,1.66-1.34,3-3,3h-4Z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    Down: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M12,24c-1.02,0-2.03-.39-2.81-1.16l-6.37-6.77c-.85-.85-1.1-2.09-.63-3.22,.47-1.13,1.52-1.84,2.75-1.85h2.06V3c0-1.65,1.35-3,3-3h4c1.65,0,3,1.35,3,3V11h2.06c1.23,0,2.28,.71,2.75,1.85,.47,1.13,.22,2.38-.65,3.24,0,0-6.34,6.74-6.35,6.75-.77,.77-1.79,1.16-2.81,1.16Z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    Refresh: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M12,0c-2.991,0-5.813,1.113-8,3.078V1c0-.553-.448-1-1-1s-1,.447-1,1V5c0,1.103,.897,2,2,2h4c.552,0,1-.447,1-1s-.448-1-1-1h-3.13c1.876-1.913,4.422-3,7.13-3,5.514,0,10,4.486,10,10s-4.486,10-10,10c-5.21,0-9.492-3.908-9.959-9.09-.049-.549-.522-.953-1.086-.906C.405,12.054,0,12.54,.049,13.09c.561,6.22,5.699,10.91,11.951,10.91,6.617,0,12-5.383,12-12S18.617,0,12,0Z"
                //  You can add stroke, strokeWidth, etc. if you need them:
                //  stroke: "currentColor",
                //  strokeWidth: 1.5,
            },
        ],
    },

    Trash: { // Choose an appropriate name for your icon
        width: "24", // Set the correct width from your SVG (or an approximation)
        height: "24", // Set the correct height from your SVG (or an approximation)
        viewBox: "0 0 512 512", // Set the correct viewBox from your SVG
        paths: [
            {
                d: "M448,85.333h-66.133C371.66,35.703,328.002,0.064,277.333,0h-42.667c-50.669,0.064-94.327,35.703-104.533,85.333H64   c-11.782,0-21.333,9.551-21.333,21.333S52.218,128,64,128h21.333v277.333C85.404,464.214,133.119,511.93,192,512h128   c58.881-0.07,106.596-47.786,106.667-106.667V128H448c11.782,0,21.333-9.551,21.333-21.333S459.782,85.333,448,85.333z    M234.667,362.667c0,11.782-9.551,21.333-21.333,21.333C201.551,384,192,374.449,192,362.667v-128   c0-11.782,9.551-21.333,21.333-21.333c11.782,0,21.333,9.551,21.333,21.333V362.667z M320,362.667   c0,11.782-9.551,21.333-21.333,21.333c-11.782,0-21.333-9.551-21.333-21.333v-128c0-11.782,9.551-21.333,21.333-21.333   c11.782,0,21.333,9.551,21.333,21.333V362.667z M174.315,85.333c9.074-25.551,33.238-42.634,60.352-42.667h42.667   c27.114,0.033,51.278,17.116,60.352,42.667H174.315z"
            }
        ]
    },
    Pencil: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M1.172,19.119A4,4,0,0,0,0,21.947V24H2.053a4,4,0,0,0,2.828-1.172L18.224,9.485,14.515,5.776Z"
            },
            {
                d: "M23.145.855a2.622,2.622,0,0,0-3.71,0L15.929,4.362l3.709,3.709,3.507-3.506A2.622,2.622,0,0,0,23.145.855Z"
            }
        ]
    },
    Chevron: {
        width: "14.002",
        height: "7.173",
        viewBox: "0 0 14.002 7.173",
        paths: [ // Use an array for multiple paths
            {
                d: "M18.71,8.21a1,1,0,0,0-1.42,0l-4.58,4.58a1,1,0,0,1-1.42,0L6.71,8.21A1,1,0,0,0,5.29,9.62l4.59,4.59a3,3,0,0,0,4.24,0l4.59-4.59A1,1,0,0,0,18.71,8.21Z",
                transform: "translate(-4.999 -7.914)"
            }
        ]
    },
    Eye: {
        width: "20",
        height: "12.422",
        viewBox: "0 0 20 12.422",
        paths: [ // Array of path objects
            {
                d: "M19.9,102.826a11.322,11.322,0,0,0-19.8,0,.781.781,0,0,0,0,.771,11.322,11.322,0,0,0,19.8,0A.781.781,0,0,0,19.9,102.826ZM10,107.859a9.808,9.808,0,0,1-8.309-4.648,9.751,9.751,0,0,1,16.618,0A9.808,9.808,0,0,1,10,107.859Z",
                transform: "translate(0 -97)"
            },
            {
                d: "M188.734,186a2.734,2.734,0,1,0,2.734,2.734A2.737,2.737,0,0,0,188.734,186Zm0,3.906a1.172,1.172,0,1,1,1.172-1.172A1.173,1.173,0,0,1,188.734,189.906Z",
                transform: "translate(7.266 3.477) translate(-186 -186)"  // Keep transforms separate
            }
        ]
    },
    EyeSlash: {
        width: "20",
        height: "12.422",
        viewBox: "0 0 20 12.422",
        paths: [
            {
                d: "M19.9,102.826a11.322,11.322,0,0,0-19.8,0,.781.781,0,0,0,0,.771,11.322,11.322,0,0,0,19.8,0A.781.781,0,0,0,19.9,102.826ZM10,107.859a9.808,9.808,0,0,1-8.309-4.648,9.751,9.751,0,0,1,16.618,0A9.808,9.808,0,0,1,10,107.859Z",
                transform: "translate(0 -97)"
            },
            {
                d: "M188.734,186a2.734,2.734,0,1,0,2.734,2.734A2.737,2.737,0,0,0,188.734,186Zm0,3.906a1.172,1.172,0,1,1,1.172-1.172A1.173,1.173,0,0,1,188.734,189.906Z",
                transform: "translate(7.266 3.477) translate(-186 -186)"
            },
            {
                d: "M2.5,11.7 L3.5,10.3 L17.5,0.7 L16.5,2.1 Z"
            }
        ]
    },
    Chat: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        paths: [
            {
                d: "M16.667,0H3.333A3.333,3.333,0,0,0,0,3.333v10a3.333,3.333,0,0,0,3.333,3.333H5.75L9.459,19.8a.833.833,0,0,0,1.077,0l3.714-3.136h2.417A3.333,3.333,0,0,0,20,13.333v-10A3.333,3.333,0,0,0,16.667,0Zm1.667,13.333A1.667,1.667,0,0,1,16.667,15H14.25a1.667,1.667,0,0,0-1.076.394L10,18.075,6.827,15.394h0A1.667,1.667,0,0,0,5.75,15H3.333a1.667,1.667,0,0,1-1.667-1.667v-10A1.667,1.667,0,0,1,3.333,1.667H16.667a1.667,1.667,0,0,1,1.667,1.667Z",
                fill: "#4384bd" // Added fill property from SVG
            },
            {
                d: "M6.833,6.667H11A.833.833,0,0,0,11,5H6.833a.833.833,0,0,0,0,1.667Z",
                transform: "translate(-1 -0.833)",
                fill: "#4384bd" // Added fill property from SVG
            },
            {
                d: "M15.167,9H6.833a.833.833,0,0,0,0,1.667h8.333a.833.833,0,1,0,0-1.667Z",
                transform: "translate(-1 -1.5)",
                fill: "#4384bd" // Added fill property from SVG
            },
            {
                d: "M15.167,13H6.833a.833.833,0,0,0,0,1.667h8.333a.833.833,0,1,0,0-1.667Z",
                transform: "translate(-1 -2.167)",
                fill: "#4384bd" // Added fill property from SVG
            }
        ]
    },
    Close: {
        width: "8",
        height: "9.595",
        viewBox: "0 0 8 9.595",
        paths: [
            {
                d: "M6.76,4.794,9.852.973A.6.6,0,1,0,8.92.22L5.989,3.841,3.057.22a.6.6,0,0,0-.932.754l3.092,3.82L2.125,8.614a.6.6,0,0,0,.932.754L5.989,5.746,8.92,9.367a.6.6,0,0,0,.932-.754L6.76,4.794Z",
                transform: "translate(-1.986 0.005)",
                fill: "#a0c1de"
            }
        ]
    },
    Entities: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        paths: [
            {
                d: "M17.51,9.17h-4.17c-1.38,0-2.5,1.12-2.5,2.5v5.83c0,1.38,1.12,2.5,2.5,2.5h4.17c1.38,0,2.5-1.12,2.5-2.5v-5.83C20.01,10.29,18.89,9.17,17.51,9.17zm-0.83,7.5h-2.5c-0.46,0-0.83-0.37-0.83-0.83s0.37-0.83,0.83-0.83h2.5c0.46,0,0.83,0.37,0.83,0.83S17.14,16.67,16.68,16.67zm0-3.33h-2.5c-0.46,0-0.83-0.37-0.83-0.83s0.37-0.83,0.83-0.83h2.5c0.46,0,0.83,0.37,0.83,0.83S17.14,13.34,16.68,13.34zM2.5,5C2.5,2.24,4.74,0,7.5,0s5,2.24,5,5s-2.24,5-5,5S2.5,7.76,2.5,5zM10.02,20H0.83C0.37,20,0,19.63,0,19.17C0,15.86,2.69,13.17,6,13.17l0,0c0.55,0,1.09,0.07,1.67,0.19v5.6C8.12,19.48,9.02,19.92,10.02,20z",
                fill: "#4384bd"
            }
        ]
    },
    Products: {
        width: "20",
        height: "19.996",
        viewBox: "0 0 20 19.996",
        paths: [
            {
                d: "M15.83.052H4.166A4.166,4.166,0,0,0,0,4.218H0a2.5,2.5,0,0,0,2.5,2.5h15A2.475,2.475,0,0,0,20,4.4,4.17,4.17,0,0,0,16.012.056Q15.921.052,15.83.052Z",
                transform: "translate(0)",
                fill: "#4384bd"
            },
            {
                d: "M38.83,213.385H22.167a.833.833,0,0,0-.833.833v6.665a4.171,4.171,0,0,0,4.166,4.166h10a4.171,4.171,0,0,0,4.166-4.166v-6.665A.833.833,0,0,0,38.83,213.385ZM33,217.551H28a.833.833,0,1,1,0-1.666h5a.833.833,0,1,1,0,1.666Z",
                transform: "translate(-20.501 -205.001)",
                fill: "#4384bd"
            }
        ]
    },
    Reports: {
        width: "20",
        height: "19.967",
        viewBox: "0 0 20 19.967",
        paths: [
            {
                d: "M19.983,19.154a.833.833,0,0,1-.833.833H2.5a2.5,2.5,0,0,1-2.5-2.5V.836a.833.833,0,0,1,1.665,0V17.489a.834.834,0,0,0,.833.833H19.151A.833.833,0,0,1,19.983,19.154ZM19.269,8.246,17.586,6.564a2.557,2.557,0,0,0-3.533,0L12.489,8.127,9.259,4.9a2.556,2.556,0,0,0-3.532,0L4.062,6.564A2.479,2.479,0,0,0,3.33,8.33v5.828a2.5,2.5,0,0,0,2.5,2.5H17.49a2.5,2.5,0,0,0,2.5-2.49L20,10.02a2.511,2.511,0,0,0-.732-1.774Z",
                transform: "translate(0 -0.019)",
                fill: "#4384bd"
            }
        ]
    },
    Search: {
        width: "15",
        height: "15.002",
        viewBox: "0 0 15 15.002",
        paths: [
            {
                d: "M14.748,13.4l-2.9-2.9a6.566,6.566,0,1,0-1.323,1.323l2.9,2.9a.935.935,0,1,0,1.322-1.322ZM6.612,11.263a4.672,4.672,0,1,1,4.672-4.672A4.672,4.672,0,0,1,6.612,11.263Z",
                transform: "translate(0 0)",
                fill: "#4384bd"
            }
        ]
    },
    Treasury: {
        width: "20.042",
        height: "20.043",
        viewBox: "0 0 20.042 20.043",
        paths: [
            {
                d: "M10.021,10.857c0,1.384-2.243,2.505-5.011,2.505S0,12.24,0,10.857,2.243,8.351,5.011,8.351,10.021,9.473,10.021,10.857Zm0,4.593v1.67c0,1.666-2.154,2.923-5.011,2.923S0,18.786,0,17.12V15.45c0,1.646,2.088,2.923,5.011,2.923S10.021,17.1,10.021,15.45Zm0-3.34v1.67c0,1.666-2.154,2.923-5.011,2.923S0,15.446,0,13.78v-1.67c0,1.646,2.088,2.923,5.011,2.923S10.021,13.755,10.021,12.109Zm5.011-7.1H8.351v1.67h6.681ZM15.867,0H7.516A4.18,4.18,0,0,0,3.34,4.176V6.8a12.074,12.074,0,0,1,3.34,0V5.011a1.672,1.672,0,0,1,1.67-1.67h6.681a1.672,1.672,0,0,1,1.67,1.67v1.67a1.672,1.672,0,0,1-1.67,1.67H10.465a3.534,3.534,0,0,1,1.109,1.67h.952a.835.835,0,0,1,.835.835v.835a.835.835,0,0,1-.835.835h-.835V14.2h4.176a.835.835,0,0,1,0,1.67H11.691V17.12a3.827,3.827,0,0,1-1.409,2.923h5.584a4.18,4.18,0,0,0,4.176-4.176V4.176A4.18,4.18,0,0,0,15.867,0ZM16.7,11.692a.835.835,0,0,1-1.67,0v-.835a.835.835,0,0,1,1.67,0Z",
                fill: "#4384bd"
            }
        ]
    },
    Sales: {
        width: "20",
        height: "20.043",
        viewBox: "0 0 20 20.043",
        paths: [
            {
                d: "M0,14.991a5,5,0,1,0,5-5A5,5,0,0,0,0,14.991Zm6.035-2.5,1.25,1.25a.732.732,0,0,1,.214.518.718.718,0,0,1-.056.28.731.731,0,0,1-.677.451H5.832v2.5a.833.833,0,0,1-1.667,0v-2.5H3.232a.731.731,0,0,1-.518-1.248l1.25-1.25a1.466,1.466,0,0,1,2.071,0ZM7.5,3.282c0-1.841,2.8-3.333,6.25-3.333S20,1.441,20,3.282s-2.8,3.333-6.25,3.333S7.5,5.123,7.5,3.282Zm6.25,6.667C17.2,9.949,20,8.456,20,6.616V4.949c0,1.841-2.8,3.333-6.25,3.333S7.5,6.79,7.5,4.949V6.616C7.5,8.456,10.3,9.949,13.75,9.949Zm0,8.376a10.911,10.911,0,0,1-2.788-.349,6.692,6.692,0,0,1-.913,1.369,10.268,10.268,0,0,0,3.7.647C17.2,19.992,20,18.5,20,16.659V14.992c0,1.841-2.8,3.333-6.25,3.333Zm0-6.667a10.57,10.57,0,0,1-3.3-.5,6.617,6.617,0,0,1,.933,1.921,11.126,11.126,0,0,0,2.363.247c3.452,0,6.25-1.493,6.25-3.333V8.325C20,10.166,17.2,11.658,13.75,11.658Zm0,3.333a11.264,11.264,0,0,1-2.086-.191c0,.063,0,.127,0,.191a6.719,6.719,0,0,1-.157,1.446,11.209,11.209,0,0,0,2.241.221c3.452,0,6.25-1.493,6.25-3.333V11.658C20,13.5,17.2,14.991,13.75,14.991Z",
                transform: "translate(0 0.051)",
                fill: "#4384bd"
            }
        ]
    },
    Users: {
        width: "20",
        height: "19.721",
        viewBox: "0 0 20 19.721",
        paths: [
            {
                d: "M10,8.333a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,10,8.333ZM7.473,12.707a2.652,2.652,0,0,1,5.052,0,.834.834,0,1,0,1.615-.417,4.318,4.318,0,0,0-8.281,0,.833.833,0,1,0,1.614.417Zm2.534,7.013A1.675,1.675,0,0,1,8.892,19.3l-3.123-2.63H3.333A3.333,3.333,0,0,1,0,13.333v-10A3.333,3.333,0,0,1,3.333,0H16.667A3.333,3.333,0,0,1,20,3.333v10a3.333,3.333,0,0,1-3.333,3.333H14.289l-3.206,2.65a1.617,1.617,0,0,1-1.076.4ZM3.333,1.667A1.667,1.667,0,0,0,1.667,3.333v10A1.667,1.667,0,0,0,3.333,15H6.074a.833.833,0,0,1,.537.2l3.372,2.842,3.477-2.847A.833.833,0,0,1,13.99,15h2.677a1.667,1.667,0,0,0,1.667-1.667v-10a1.667,1.667,0,0,0-1.667-1.667Z",
                fill: "#4384bd"
            }
        ]
    },
    Warning: {
        width: "20",
        height: "17.51",
        viewBox: "0 0 20 17.51",
        paths: [
            {
                d: "M9.173,11.006V6a.834.834,0,0,1,1.668,0v5a.834.834,0,0,1-1.668,0Zm.834,1.668a1.251,1.251,0,1,0,1.251,1.251A1.249,1.249,0,0,0,10.007,12.673Zm9.655,4.069a3.571,3.571,0,0,1-3.344,1.768H3.7A3.563,3.563,0,0,1,.36,16.742a3.7,3.7,0,0,1,.417-3.8l6.7-10.606A3.062,3.062,0,0,1,10.007,1a3.024,3.024,0,0,1,2.5,1.309l6.737,10.648a3.671,3.671,0,0,1,.409,3.785ZM17.87,13.89a.058.058,0,0,1-.017-.033L11.124,3.226a1.389,1.389,0,0,0-2.251.033l-6.712,10.6a2.073,2.073,0,0,0-.334,2.109,1.954,1.954,0,0,0,1.868.875H16.3a1.954,1.954,0,0,0,1.868-.875,2.051,2.051,0,0,0-.309-2.076Z",
                transform: "translate(-0.008 -1)",
                fill: "#4384bd"
            }
        ]
    },
    Plus: {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        paths: [
            {
                d: "M17,11H13V7a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v4H7a1,1,0,0,0-1,1H6a1,1,0,0,0,1,1h4v4a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V13h4a1,1,0,0,0,1-1h0A1,1,0,0,0,17,11Z",
                transform: "translate(-6 -6)",
                fill: "#fff"
            }
        ]
    },
    DarkModeToggle: {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        paths: [
            {
                d: "M100 15 L100 40 M100 160 L100 185 M15 100 L40 100 M160 100 L185 100 M37 37 L54 54 M146 146 L163 163 M37 163 L54 146 M146 54 L163 37",
                stroke: "#8BADC1",
                strokeWidth: "6",  // Using camelCase for consistency
                strokeLinecap: "round" // Using camelCase for consistency
            },
            {
                d: "M100 100 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0", // Circle as path
                stroke: "#8BADC1",
                strokeWidth: "6"
            },
            {
                d: "M100 80 A 25 25 0 0 1 125 100 A 25 25, 0, 0, 1 100 120",  // Simplified moon path
            }
        ]
    },
    Clipboard: { // Choose an appropriate name for your icon
        width: "20",
        height: "18.333",
        viewBox: "0 0 20 18.333",
        paths: [
            {
                d: "M15.833,1H4.167A4.167,4.167,0,0,0,0,5.167v6.667A4.167,4.167,0,0,0,4.167,16h5v1.667H5.833a.833.833,0,1,0,0,1.667h8.333a.833.833,0,1,0,0-1.667H10.833V16h5A4.167,4.167,0,0,0,20,11.833V5.167A4.167,4.167,0,0,0,15.833,1ZM5.668,12.966a4.169,4.169,0,0,1,.165-8.133V8.571a1.667,1.667,0,0,0,.488,1.178L8.962,12.39a4.169,4.169,0,0,1-3.293.576Zm4.473-1.754-2.4-2.4A.833.833,0,0,1,7.5,8.227V4.834a4.161,4.161,0,0,1,2.64,6.378Zm6.527,1.455h-2.5a.833.833,0,1,1,0-1.667h2.5a.833.833,0,0,1,0,1.667Zm0-3.333h-2.5a.833.833,0,1,1,0-1.667h2.5a.833.833,0,0,1,0,1.667Zm0-3.333h-2.5a.833.833,0,1,1,0-1.667h2.5a.833.833,0,0,1,0,1.667Z",
                transform: "translate(0 -1)",
                fill: "#4384bd"
            }
        ]
    },
    Bell1: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M8.35179 20.2418C9.19288 21.311 10.5142 22 12 22C13.4858 22 14.8071 21.311 15.6482 20.2418C13.2264 20.57 10.7736 20.57 8.35179 20.2418Z",
                fill: "#1C274C"
            },
            {
                d: "M18.7491 9V9.7041C18.7491 10.5491 18.9903 11.3752 19.4422 12.0782L20.5496 13.8012C21.5612 15.3749 20.789 17.5139 19.0296 18.0116C14.4273 19.3134 9.57274 19.3134 4.97036 18.0116C3.21105 17.5139 2.43882 15.3749 3.45036 13.8012L4.5578 12.0782C5.00972 11.3752 5.25087 10.5491 5.25087 9.7041V9C5.25087 5.13401 8.27256 2 12 2C15.7274 2 18.7491 5.13401 18.7491 9Z",
                fill: "#1C274C"
            }
        ]
    },
    Logout: { // I've named it "Bell" - you can adjust this
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m24,15c0,.617-.24,1.197-.678,1.634l-2.072,2.073c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023,0-1.414l1.292-1.293h-6.128c-.553,0-1-.447-1-1s.447-1,1-1h6.128l-1.292-1.293c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l2.073,2.074c.437.436.677,1.016.677,1.633Zm-10-4v-5c0-1.103-.897-2-2-2h0s0,0,0,0v17.999h1c.552,0,1-.448,1-1v-2c0-.553.447-1,1-1s1,.447,1,1v2c0,1.654-1.346,3-3,3H3c-1.654,0-3-1.346-3-3V5.621C0,3.246,1.69,1.184,4.019.718L7.216.079c1.181-.236,2.391.066,3.321.829.375.307.665.685.902,1.092h.561c2.206,0,4,1.794,4,4v5c0,.553-.447,1-1,1s-1-.447-1-1Zm-5,1.5c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5,1.5.672,1.5,1.5,1.5,1.5-.672,1.5-1.5Z",
                fill: "#1C274C"
            }
        ]
    },
    Bell: { // Or any suitable name for this icon
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M7.424,21a4.99,4.99,0,0,0,9.152,0Z"
            },
            {
                d: "M22.392,12.549,20.656,6.826A9.321,9.321,0,0,0,2.58,7.28L1.232,12.817A5,5,0,0,0,6.09,19H17.607a5,5,0,0,0,4.785-6.451Z"
            }
        ]
    },
    Sun: { // Or any suitable name for this icon
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M23,11H19.938a7.956,7.956,0,0,0-.575-2.129l2.655-1.546A1,1,0,0,0,21.012,5.6L18.354,7.145a8.1,8.1,0,0,0-1.507-1.5l1.541-2.648a1,1,0,0,0-1.729-1.006L15.12,4.633A7.971,7.971,0,0,0,13,4.062V1a1,1,0,0,0-2,0V4.062a7.965,7.965,0,0,0-2.108.566L7.355,1.986A1,1,0,1,0,5.627,2.992L7.163,5.633A8.046,8.046,0,0,0,5.651,7.139L3,5.6A1,1,0,0,0,2,7.325L4.64,8.865A7.955,7.955,0,0,0,4.062,11H1a1,1,0,0,0,0,2H4.062a7.957,7.957,0,0,0,.576,2.129L2,16.662A1,1,0,0,0,3.01,18.391l2.637-1.535a8.083,8.083,0,0,0,1.5,1.5L5.6,21A1,1,0,0,0,7.33,22.007l1.538-2.646A7.943,7.943,0,0,0,11,19.938V23a1,1,0,0,0,2,0V19.938a7.934,7.934,0,0,0,2.143-.582l1.543,2.651A1,1,0,0,0,18.414,21l-1.546-2.657a8.076,8.076,0,0,0,1.49-1.494l2.647,1.541a1,1,0,0,0,1.006-1.729l-2.646-1.54A7.941,7.941,0,0,0,19.938,13H23A1,1,0,0,0,23,11Zm-9.182,5.714C6.862,18.876,4.051,8.627,11.2,7.064a5.468,5.468,0,0,1,2.1.085.68.68,0,0,1,.3,1.148,4.618,4.618,0,0,0,.4,7.241A.681.681,0,0,1,13.818,16.714Z"
            }
        ]
    },
    Settings: { // Or any suitable name for this icon
        width: "24.051",
        height: "24.051",
        viewBox: "0 0 512.051 512.051",
        paths: [
            {
                d: "M21.359,101.359h58.368c11.52,42.386,55.219,67.408,97.605,55.888c27.223-7.399,48.489-28.665,55.888-55.888h257.472 c11.782,0,21.333-9.551,21.333-21.333s-9.551-21.333-21.333-21.333H233.22C221.7,16.306,178.001-8.716,135.615,2.804 c-27.223,7.399-48.489,28.665-55.888,55.888H21.359c-11.782,0-21.333,9.551-21.333,21.333S9.577,101.359,21.359,101.359z"
            },
            {
                d: "M490.692,234.692h-58.368c-11.497-42.38-55.172-67.416-97.552-55.92c-27.245,7.391-48.529,28.674-55.92,55.92H21.359 c-11.782,0-21.333,9.551-21.333,21.333c0,11.782,9.551,21.333,21.333,21.333h257.493c11.497,42.38,55.172,67.416,97.552,55.92 c27.245-7.391,48.529-28.674,55.92-55.92h58.368c11.782,0,21.333-9.551,21.333-21.333 C512.025,244.243,502.474,234.692,490.692,234.692z"
            },
            {
                d: "M490.692,410.692H233.22c-11.52-42.386-55.219-67.408-97.605-55.888c-27.223,7.399-48.489,28.665-55.888,55.888H21.359 c-11.782,0-21.333,9.551-21.333,21.333c0,11.782,9.551,21.333,21.333,21.333h58.368c11.52,42.386,55.219,67.408,97.605,55.888 c27.223-7.399,48.489-28.665,55.888-55.888h257.472c11.782,0,21.333-9.551,21.333-21.333 C512.025,420.243,502.474,410.692,490.692,410.692z"
            }
        ]
    },
    Functions: { // Or any suitable name for this icon
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M18,7c0-2.757-2.243-5-5-5h-.171c-.413-1.164-1.525-2-2.829-2h-2c-1.304,0-2.416,.836-2.829,2h-.171C2.243,2,0,4.243,0,7v12c0,2.757,2.243,5,5,5H13c.068,0,.131-.017,.199-.02-1.652-1.466-2.699-3.598-2.699-5.98,0-.34,.029-.672,.07-1H5c-.552,0-1-.447-1-1s.448-1,1-1h6.083c.295-.727,.697-1.398,1.181-2H5c-.552,0-1-.447-1-1s.448-1,1-1H14.657c1.004-.551,2.135-.9,3.343-.975v-3.025Zm-5,2H5c-.552,0-1-.447-1-1s.448-1,1-1H13c.552,0,1,.447,1,1s-.448,1-1,1Zm10.332,10.63l-.55-.317c.129-.418,.218-.853,.218-1.312s-.089-.895-.218-1.312l.55-.317c.479-.276,.643-.887,.367-1.366-.276-.478-.887-.643-1.365-.367l-.544,.314c-.605-.652-1.393-1.126-2.289-1.331v-.621c0-.552-.448-1-1-1h0c-.552,0-1,.448-1,1v.621c-.896,.205-1.685,.678-2.289,1.331l-.544-.314c-.478-.276-1.09-.111-1.365,.367-.276,.479-.112,1.09,.367,1.366l.55,.317c-.129,.418-.218,.853-.218,1.312s.089,.895,.218,1.312l-.55,.317c-.479,.276-.643,.887-.367,1.366,.276,.478,.887,.643,1.365,.367l.544-.314c.605,.652,1.393,1.126,2.289,1.331v.621c0,.552,.448,1,1,1h0c.552,0,1-.448,1-1v-.621c.896-.205,1.685-.678,2.289-1.331l.544,.314c.478,.276,1.09,.111,1.365-.367,.276-.479,.112-1.09-.367-1.366Zm-4.832-.13c-.827,0-1.5-.673-1.5-1.5s.673-1.5,1.5-1.5,1.5,.673,1.5,1.5-.673,1.5-1.5,1.5Z"
            }
        ]
    },
    Flask: { // Or any suitable name for this icon
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m17.929,9.891c-.59-.56-.929-1.351-.929-2.17V2h1c.553,0,1-.448,1-1s-.447-1-1-1H6c-.553,0-1,.448-1,1s.447,1,1,1h1v5.721c0,.819-.339,1.61-.929,2.169-1.281,1.214-3.052,3.066-4.35,5.11h17.279c.553,0,1,.448,1,1s-.447,1-1,1H.653c-.406.956-.653,1.922-.653,2.857,0,.862.23,1.648.685,2.334.747,1.132,2.059,1.809,3.508,1.809h15.615c1.449,0,2.761-.676,3.507-1.808.455-.688.686-1.473.686-2.335,0-3.667-3.804-7.818-6.071-9.966Z"
            }
        ]
    },
    ChevronLeft: { // Or any suitable name for this icon
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M10.957,12.354a.5.5,0,0,1,0-.708l4.586-4.585a1.5,1.5,0,0,0-2.121-2.122L8.836,9.525a3.505,3.505,0,0,0,0,4.95l4.586,4.586a1.5,1.5,0,0,0,2.121-2.122Z"
            }
        ]
    },
    ChevronRight: { // Or any suitable name for this icon
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M15.75,9.525,11.164,4.939A1.5,1.5,0,0,0,9.043,7.061l4.586,4.585a.5.5,0,0,1,0,.708L9.043,16.939a1.5,1.5,0,0,0,2.121,2.122l4.586-4.586A3.505,3.505,0,0,0,15.75,9.525Z"
            }
        ]
    },
    UserEdit: { // Or any suitable name for this icon
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M9,12c-3.309,0-6-2.691-6-6S5.691,0,9,0s6,2.691,6,6-2.691,6-6,6Zm4.27,7.48c-.813,.813-1.27,1.915-1.27,3.065v1.455h1.455c1.15,0,2.252-.457,3.065-1.27l6.807-6.807c.897-.897,.897-2.353,0-3.25-.897-.897-2.353-.897-3.25,0l-6.807,6.807Zm-3.27,3.065c0-1.692,.659-3.283,1.855-4.479l2.376-2.376c-1.476-1.06-3.279-1.691-5.231-1.691C4.038,14,0,18.038,0,23c0,.552,.448,1,1,1H10v-1.455Z"
            }
        ]
    },
    DocImport: { // Or any suitable name for this icon
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m14,7.015V.474c.913.346,1.753.879,2.465,1.59l3.484,3.486c.712.711,1.245,1.551,1.591,2.464h-6.54c-.552,0-1-.449-1-1Zm7.976,3h-6.976c-1.654,0-3-1.346-3-3V.038c-.161-.011-.322-.024-.485-.024h-4.515C4.243.015,2,2.258,2,5.015v8.985h8.398l-1.293-1.293c-.391-.391-.391-1.024,0-1.414.391-.391,1.023-.391,1.414,0l1.613,1.614c1.154,1.154,1.154,3.032,0,4.187l-1.613,1.614c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.39-.391-1.023,0-1.414l1.293-1.293H2v3.015c0,2.757,2.243,5,5,5h10c2.757,0,5-2.243,5-5v-8.515c0-.163-.013-.324-.024-.485Z"
            }
        ]
    },
    DocExport: { // Or any suitable name for this icon
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",

        paths: [
            {
                d: "M23.13,18.09l-1.61,1.61c-.2,.2-.45,.29-.71,.29s-.51-.1-.71-.29c-.39-.39-.39-1.02,0-1.41l1.29-1.29h-7.4c-.55,0-1-.45-1-1s.45-1,1-1h7.4l-1.29-1.29c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l1.61,1.61c1.15,1.15,1.15,3.03,0,4.19ZM13,8h6.54c-.35-.91-.88-1.75-1.59-2.46l-3.48-3.49c-.71-.71-1.55-1.24-2.46-1.59V7c0,.55,.45,1,1,1Zm4.81,11h-3.81c-1.65,0-3-1.35-3-3s1.35-3,3-3h3.81c0-.77,.29-1.54,.88-2.12,.37-.37,.82-.63,1.29-.76v-.12h-6.98c-1.65,0-3-1.35-3-3V.02c-.16-.01-.32-.02-.49-.02H5C2.24,0,0,2.24,0,5v14c0,2.76,2.24,5,5,5H15c1.81,0,3.4-.97,4.28-2.42-.21-.13-.41-.28-.59-.46-.58-.58-.88-1.35-.88-2.12Z"
            }
        ]
    },
    Briefcase: { // Or any suitable name for this icon
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M19,12h5v7c0,2.757-2.243,5-5,5H5c-2.757,0-5-2.243-5-5v-7H5v1c0,.552,.447,1,1,1s1-.448,1-1v-1h10v1c0,.552,.447,1,1,1s1-.448,1-1v-1Zm5-3v1h-5v-1c0-.552-.447-1-1-1s-1,.448-1,1v1H7v-1c0-.552-.447-1-1-1s-1,.448-1,1v1H0v-1c0-2.757,2.243-5,5-5h1.101C6.566,1.721,8.586,0,11,0h2c2.414,0,4.434,1.721,4.899,4h1.101c2.757,0,5,2.243,5,5ZM8.184,4h7.631c-.414-1.161-1.514-2-2.816-2h-2c-1.302,0-2.402,.839-2.816,2Z"
            }
        ]
    },
    menuExpand: { // Name matches the requested key
        width: "24",    // Extracted from the SVG's width attribute
        height: "24",   // Extracted from the SVG's height attribute
        viewBox: "0 0 24 24", // Extracted from the SVG's viewBox attribute
        paths: [ // Array for the multiple <path> elements
            {
                d: "M1,6H23a1,1,0,0,0,0-2H1A1,1,0,0,0,1,6Z" // d attribute from the first path
            },
            {
                d: "M23,9H9a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z" // d attribute from the second path
            },
            {
                d: "M23,19H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z" // d attribute from the third path
            },
            {
                d: "M23,14H9a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z" // d attribute from the fourth path
            },
            {
                d: "M1.707,16.245l2.974-2.974a1.092,1.092,0,0,0,0-1.542L1.707,8.755A1,1,0,0,0,0,9.463v6.074A1,1,0,0,0,1.707,16.245Z" // d attribute from the fifth path
            }
        ]
    }, // Add a comma here if adding more icons after this one
    menuCollapse: {
        width: "24",          // As requested
        height: "24",         // As requested
        viewBox: "0 0 24 24", // From the SVG's viewBox attribute
        paths: [
            {
                d: "m0,5c0-.553.448-1,1-1h22c.552,0,1,.447,1,1s-.448,1-1,1H1c-.552,0-1-.447-1-1Zm23,14H1c-.552,0-1,.447-1,1s.448,1,1,1h22c.552,0,1-.447,1-1s-.448-1-1-1Zm0-10h-14c-.552,0-1,.447-1,1s.448,1,1,1h14c.552,0,1-.447,1-1s-.448-1-1-1Zm0,5h-14c-.552,0-1,.447-1,1s.448,1,1,1h14c.552,0,1-.447,1-1s-.448-1-1-1Zm-19.707,2.245c.63.63,1.707.184,1.707-.707v-6.075c0-.891-1.077-1.337-1.707-.707L.319,11.729c-.426.426-.426,1.116,0,1.542l2.974,2.974Z"
            }
        ]
    },
    Plus: { // Choose a descriptive name for your new icon, e.g., "Add" or "PlusCircle"
        width: "24", // Set the correct width from your SVG
        height: "24", // Set the correct height from your SVG
        viewBox: "0 0 24 24", // Set the correct viewBox from your SVG
        paths: [
            {
                d: "M17,11H13V7a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1v4H7a1,1,0,0,0-1,1H6a1,1,0,0,0,1,1h4v4a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V13h4a1,1,0,0,0,1-1h0A1,1,0,0,0,17,11Z",
                fill: "#fff" // If there's a fill color, specify it here
            }
        ]
    },
    Minus: { // Or "Minus", "Line", etc. - choose the best name
        width: "24", // From the SVG
        height: "24", // From the SVG
        viewBox: "0 0 24 24", // From the SVG
        paths: [
            {
                d: "M7,11a1,1,0,0,0,0,2H17a1,1,0,0,0,0-2Z" // The path data
            }
        ]
    },
    Checkmark: {
        width: "24",
        height: "24",
        viewBox: "0 0 465.822 465.822",
        paths: [
            {
                d: "M5.988,289.981l88.875,88.875c24.992,24.984,65.504,24.984,90.496,0l274.475-274.475c8.185-8.475,7.95-21.98-0.525-30.165   c-8.267-7.985-21.374-7.985-29.641,0L155.194,348.691c-8.331,8.328-21.835,8.328-30.165,0l-88.875-88.875   c-8.475-8.185-21.98-7.95-30.165,0.525C-1.996,268.608-1.996,281.714,5.988,289.981L5.988,289.981z"
            }
        ]
    },
    DoubleChevronRight0: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m10.721,18.342l-5.281-5.281c-.283-.283-.439-.66-.439-1.061s.156-.777.439-1.061l5.281-5.281.707.707-5.281,5.281c-.094.095-.146.22-.146.354s.052.259.146.354l5.281,5.281-.707.707Zm8.052-.707l-5.635-5.635,5.635-5.635-.707-.707-5.871,5.871c-.26.26-.26.683,0,.942l5.871,5.871.707-.707Z"
            }
        ]
    },
    DoubleChevronRight: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M11.832,24a1.5,1.5,0,0,1-1.061-2.561l7.672-7.671a2.5,2.5,0,0,0,0-3.536L10.771,2.561A1.5,1.5,0,0,1,12.893.439l7.671,7.672a5.5,5.5,0,0,1,0,7.778l-7.671,7.672A1.5,1.5,0,0,1,11.832,24Z"
            },
            {
                d: "M2.287,24a1.5,1.5,0,0,1-1.06-2.561l9.085-9.085a.5.5,0,0,0,0-.708L1.227,2.561A1.5,1.5,0,0,1,3.348.439l9.086,9.086a3.507,3.507,0,0,1,0,4.949L3.348,23.561A1.5,1.5,0,0,1,2.287,24Z"
            }
        ]
    },
    WarningTriangle: {
        width: "24", // Using the viewBox dimensions for typical icon size
        height: "24", // Using the viewBox dimensions for typical icon size
        viewBox: "0 0 24 24", // The original viewBox
        paths: [
            {
                d: "M23.08,15.33L15,2.57c-.68-.98-1.81-1.57-3-1.57s-2.32,.58-3.03,1.6L.93,15.31c-1.02,1.46-1.21,3.21-.5,4.56,.7,1.35,2.17,2.12,4.01,2.12h15.12c1.85,0,3.31-.77,4.01-2.12,.7-1.35,.51-3.09-.49-4.54ZM11,7c0-.55,.45-1,1-1s1,.45,1,1v6c0,.55-.45,1-1,1s-1-.45-1-1V7Zm1,12c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5,1.5,.67,1.5,1.5-.67,1.5-1.5,1.5Z"
            }
        ]
    },

    CheckmarkCircle: {
        width: "24", // Using the viewBox dimensions for typical icon size
        height: "24", // Using the viewBox dimensions for typical icon size
        viewBox: "0 0 24 24", // The original viewBox
        paths: [
            {
                d: "m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm6.2,10.512l-4.426,4.345c-.783.768-1.791,1.151-2.8,1.151-.998,0-1.996-.376-2.776-1.129l-1.899-1.867c-.394-.387-.399-1.02-.012-1.414.386-.395,1.021-.4,1.414-.012l1.893,1.861c.776.75,2.001.746,2.781-.018l4.425-4.344c.393-.388,1.024-.381,1.414.013.387.394.381,1.027-.014,1.414Z"
            }
        ]
    },
    AlertOctagon: { //  Descriptive name
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m22.242,5.272l-3.515-3.515c-1.133-1.133-2.64-1.757-4.242-1.757h-4.971c-1.603,0-3.109.624-4.242,1.757l-3.515,3.514c-1.134,1.133-1.758,2.64-1.758,4.243v4.971c0,1.603.624,3.11,1.758,4.243l3.515,3.515c1.133,1.133,2.64,1.757,4.242,1.757h4.971c1.603,0,3.109-.624,4.242-1.757l3.515-3.514c1.134-1.133,1.758-2.64,1.758-4.243v-4.971c0-1.603-.624-3.11-1.758-4.243Zm-11.242.728c0-.552.447-1,1-1s1,.448,1,1v8c0,.552-.447,1-1,1s-1-.448-1-1V6Zm1,13c-.828,0-1.5-.672-1.5-1.5s.672-1.5,1.5-1.5s1.5.672,1.5-1.5-.672,1.5-1.5,1.5Z"
                // No transform or fill attributes in the original SVG
            }
        ]
    },
    Info: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M12,24A12,12,0,1,0,0,12,12.013,12.013,0,0,0,12,24ZM12,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12,5Zm-1,5h1a2,2,0,0,1,2,2v6a1,1,0,0,1-2,0V12H11a1,1,0,0,1,0-2Z"
            }
        ]
    },
    Minus: { // Name for the icon (e.g., "Minus", "Remove", "HorizontalLine")
        width: "24",         // from viewBox
        height: "24",        // from viewBox
        viewBox: "0 0 24 24", // from SVG's viewBox attribute
        paths: [
            {
                d: "M7,11a1,1,0,0,0,0,2H17a1,1,0,0,0,0-2Z" // path data from SVG
            }
            // No fill or transform attributes were present on this path in the SVG
        ]
    },
    ExpandMenu: { // Added a more descriptive name
        width: "24",  // From the SVG
        height: "24", // From the SVG
        viewBox: "0 0 24 24", // From the SVG
        paths: [
            {
                d: "M1,6H23a1,1,0,0,0,0-2H1A1,1,0,0,0,1,6Z"
            },
            {
                d: "M23,9H9a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z"
            },
            {
                d: "M23,19H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z"
            },
            {
                d: "M23,14H9a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z"
            },
            {
                d: "M1.707,16.245l2.974-2.974a1.092,1.092,0,0,0,0-1.542L1.707,8.755A1,1,0,0,0,0,9.463v6.074A1,1,0,0,0,1.707,16.245Z"
            }
        ]
    },
    License: { // This appears to be the same "License" icon definition as the first one you provided
        width: "24", // Extracted from the SVG's width attribute
        height: "24", // Extracted from the SVG's height attribute
        viewBox: "0 0 24 24", // Extracted from the SVG's viewBox attribute
        paths: [ // Array for the multiple <path> elements
            {
                d: "M16 .3a4.968 4.968 0 0 1 1.879 1.164l1.656 1.658a4.954 4.954 0 0 1 1.165 1.878h-4.7zm5 6.7v12a5.006 5.006 0 0 1 -5 5h-8a5.006 5.006 0 0 1 -5-5v-14a5.006 5.006 0 0 1 5-5h6v5a2 2 0 0 0 2 2zm-4.192 10.413a1 1 0 0 0 -1.4-.222 4.586 4.586 0 0 1 -2.273.809 1.347 1.347 0 0 1 -.864-.345 3.025 3.025 0 0 0 -1.832-.655 5.861 5.861 0 0 0 -3.046 1.206 1 1 0 1 0 1.214 1.588 3.951 3.951 0 0 1 1.832-.794c.246 0 .371.078.7.3a3.252 3.252 0 0 0 2 .7 6.464 6.464 0 0 0 3.456-1.193 1 1 0 0 0 .213-1.394zm.192-3.413a1 1 0 0 0 -1-1h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1zm0-4a1 1 0 0 0 -1-1h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1z" // d attribute from the path
            }
        ]
    },
    License2: { // Or any suitable name for this icon
        width: "24", // Extracted from the SVG's width attribute
        height: "24", // Extracted from the SVG's height attribute
        viewBox: "0 0 24 24", // Extracted from the SVG's viewBox attribute
        paths: [ // Array for the multiple <path> elements
            {
                d: "m18 13a3.987 3.987 0 0 0 -2 7.444v2.833a.721.721 0 0 0 1.231.51l.769-.768.769.768a.721.721 0 0 0 1.231-.51v-2.833a3.987 3.987 0 0 0 -2-7.444z" // d attribute from the first path
            },
            {
                d: "m12 17a5.993 5.993 0 0 1 9-5.191v-6.809a5.006 5.006 0 0 0 -5-5h-8a5.006 5.006 0 0 0 -5 5v12a5.006 5.006 0 0 0 5 5h6v-.54a5.975 5.975 0 0 1 -2-4.46zm-4-13h8a1 1 0 0 1 0 2h-8a1 1 0 0 1 0-2zm0 4h8a1 1 0 0 1 0 2h-8a1 1 0 0 1 0-2zm3 6h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2z" // d attribute from the second path
            }
        ]
    },
    PowerOff: { // Or any suitable name for this icon (e.g., "Timer")
        width: "24", // Extracted from the SVG's width attribute
        height: "24", // Extracted from the SVG's height attribute
        viewBox: "0 0 512.301 512.301", // Extracted from the SVG's viewBox attribute
        paths: [ // Array for the multiple <path> elements
            {
                d: "M320.119,82.112L320.119,82.112c0.137,8.67,5.409,16.432,13.419,19.755c71.67,31.535,117.01,103.433,114.581,181.696   c-1.72,106.039-89.076,190.605-195.115,188.885c-106.039-1.72-190.606-89.076-188.885-195.115c0,0,0,0,0,0   c0.101-76.006,45.028-144.798,114.581-175.445c8.013-3.343,13.282-11.117,13.419-19.797l0,0c0.019-11.782-9.518-21.348-21.3-21.367   c-2.745-0.004-5.466,0.521-8.012,1.548C43.898,113.824-10.705,252.01,40.848,370.919S230.586,544.43,349.495,492.878   c118.909-51.552,173.511-189.738,121.959-308.647c-23.698-54.66-67.299-98.261-121.959-121.959   c-10.913-4.442-23.36,0.804-27.802,11.716C320.643,76.568,320.108,79.327,320.119,82.112z" // d attribute from the first path
            },
            {
                d: "M256.119,0L256.119,0c11.782,0,21.333,9.551,21.333,21.333v128c0,11.782-9.551,21.333-21.333,21.333l0,0   c-11.782,0-21.333-9.551-21.333-21.333v-128C234.785,9.551,244.337,0,256.119,0z" // d attribute from the second path
            }
        ]
    },
    SortAsc: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M24,16c0,.553-.447,1-1,1H10c-.553,0-1-.447-1-1s.447-1,1-1h13c.553,0,1,.447,1,1Zm-14-4h10c.553,0,1-.447,1-1s-.447-1-1-1H10c-.553,0-1,.447-1,1s.447,1,1,1Zm0-5h7c.553,0,1-.447,1-1s-.447-1-1-1h-7c-.553,0-1,.447-1,1s.447,1,1,1Zm0-5h4c.553,0,1-.447,1-1s-.447-1-1-1h-4c-.553,0-1,.447-1,1s.447,1,1,1Zm-.879,17.293c-.391-.391-1.023-.391-1.414,0l-1.707,1.707V1c0-.553-.447-1-1-1s-1,.447-1,1V21l-1.707-1.707c-.391-.391-1.023-.391-1.414,0s-.391,1.023,0,1.414l2.707,2.707c.39,.39,.902,.585,1.414,.585s1.024-.195,1.414-.585l2.707-2.707c.391-.391,.391-1.023,0-1.414Z"
            }
        ]
    },

    SortDesc: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M24,1c0,.553-.448,1-1,1H10c-.552,0-1-.447-1-1s.448-1,1-1h13c.552,0,1,.447,1,1Zm-4,4H10c-.552,0-1,.447-1,1s.448,1,1,1h10c.552,0,1-.447,1-1s-.448-1-1-1Zm-3,5h-7c-.552,0-1,.447-1,1s.448,1,1,1h7c.552,0,1-.447,1-1s-.448-1-1-1Zm-3,5h-4c-.552,0-1,.447-1,1s.448,1,1,1h4c.552,0,1-.447,1-1s-.448-1-1-1Zm-4.879,4.293c-.391-.391-1.023-.391-1.414,0l-1.707,1.707V1c0-.553-.448-1-1-1s-1,.447-1,1V21l-1.708-1.708c-.391-.391-1.023-.391-1.414,0s-.391,1.023,0,1.414l2.707,2.707c.39,.39,.902,.585,1.415,.585s1.024-.195,1.414-.585l2.707-2.707c.391-.391,.391-1.023,0-1.414Z"
            }
        ]
    },
    Sort: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M12.707,17.707c.391,.391,.391,1.023,0,1.414l-4.293,4.293c-.39,.39-.902,.585-1.414,.585s-1.024-.195-1.414-.585L1.293,19.121c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l3.293,3.293V1c0-.553,.448-1,1-1s1,.447,1,1V21l3.293-3.293c.391-.391,1.023-.391,1.414,0ZM22.707,4.879L18.414,.586c-.779-.779-2.049-.779-2.828,0l-4.293,4.293c-.391,.391-.391,1.023,0,1.414s1.023,.391,1.414,0l3.293-3.293V23c0,.553,.447,1,1,1s1-.447,1-1V3l3.293,3.293c.195,.195,.451,.293,.707,.293s.512-.098,.707-.293c.391-.391,.391-1.023,0-1.414Z"
            }
        ]
    },
    Filter: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m11,22c-.212,0-.423-.068-.6-.2l-4-3c-.252-.188-.4-.485-.4-.8v-3.63L.944,8.471c-.609-.71-.944-1.616-.944-2.551,0-2.162,1.758-3.92,3.92-3.92h10.16c2.162,0,3.92,1.758,3.92,3.92,0,.935-.335,1.841-.944,2.551l-5.056,5.899v6.63c0,.379-.214.725-.553.895-.142.071-.295.105-.447.105Zm13-2c0-.552-.448-1-1-1h-8c-.552,0-1,.448-1,1s.448,1,1,1h8c.552,0,1-.448,1-1Zm0-4c0-.552-.448-1-1-1h-8c-.552,0-1,.448-1,1s.448,1,1,1h8c.552,0,1-.448,1-1Zm0-4c0-.552-.448-1-1-1h-5c-.552,0-1,.448-1,1s.448,1,1,1h5c.552,0,1-.448,1-1Z"
            }
        ]
    },
    Clock: { // Or any suitable name for this icon
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M12,0A11.972,11.972,0,0,0,4,3.073V1A1,1,0,0,0,2,1V4A3,3,0,0,0,5,7H8A1,1,0,0,0,8,5H5a.854.854,0,0,1-.1-.021A9.987,9.987,0,1,1,2,12a1,1,0,0,0-2,0A12,12,0,1,0,12,0Z"
            },
            {
                d: "M12,6a1,1,0,0,0-1,1v5a1,1,0,0,0,.293.707l3,3a1,1,0,0,0,1.414-1.414L13,11.586V7A1,1,0,0,0,12,6Z"
            }
        ]
    },
    Certificate: { // Renamed to a more specific name based on icon content
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m14,9.5c0,1.103-.897,2-2,2s-2-.897-2-2,.897-2,2-2,2,.897,2,2Zm7.168-1.283c-.239-.431-.557-.761-.918-.995-.644-.416-.987-1.181-.817-1.928.097-.429.091-.897-.048-1.381-.246-.859-.946-1.559-1.805-1.805-.484-.139-.952-.145-1.38-.048-.748.17-1.513-.172-1.929-.817-.233-.361-.564-.679-.994-.918-.782-.433-1.771-.433-2.553,0-.431.239-.761.557-.994.918-.416.644-1.181.987-1.929.817-.428-.097-.896-.091-1.38.048-.859.246-1.559.946-1.805,1.805-.139.484-.145.953-.048,1.381.17.748-.173,1.513-.817,1.928-.362.233-.679.564-.918.995-.219.394-.325.842-.323,1.289-.002.447.105.894.323,1.289.239.431.557.761.918.995.644.416.987,1.181.817,1.928-.097.429-.091.897.048,1.382.246.859.946,1.559,1.805,1.805.484.139.952.145,1.38.048.748-.17,1.513.172,1.929.817.233.361.563.679.994.918.782.433,1.772.433,2.553,0,.431-.239.761-.557.994-.918.416-.644,1.181-.987,1.929-.817.428.097.896.091,1.38-.048.859-.246,1.559-.946,1.805-1.805.139-.484.145-.953.048-1.382-.17-.748.173-1.513.817-1.928.362-.233.679-.564.918-.995.219-.394.325-.842.323-1.289.002-.447-.105-.894-.323-1.289Zm-9.179,5.285c-2.206,0-4-1.794-4-4s1.794-4,4-4,4,1.794,4,4-1.794,4-4,4Zm-3.888,5.43c-.726.142-1.496.106-2.231-.105-1.426-.408-2.576-1.506-3.076-2.894l-2.306,2.223c-.972.938-.405,2.584.939,2.723l1.765.182.218,1.568c.179,1.291,1.751,1.828,2.683.917l3.401-3.296c-.553-.355-1.033-.784-1.393-1.318Zm6.406,1.318l3.401,3.296c.932.911,2.504.374,2.683-.917l.218-1.568,1.765-.182c1.344-.139,1.911-1.785.939-2.723l-2.306-2.223c-.5,1.388-1.65,2.486-3.076,2.894-.735.211-1.505.247-2.231.105-.36.534-.84.963-1.393,1.318Z"
            }
        ]
    },
    Store: { // New icon added
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M23.962,7.725l-1.172-4.099c-.61-2.135-2.588-3.626-4.808-3.626h-.982V4c-.006,1.308-1.995,1.307-2,0V0h-6V4c-.006,1.308-1.994,1.307-2,0V0h-.983C3.797,0,1.82,1.491,1.209,3.626L.039,7.725c-.161,1.066,.314,2.138,.961,2.893v9.382c0,2.206,1.794,4,4,4h6c2.206,0,4-1.794,4-4V11.444c.378-.221,.714-.498,1-.826,.734,.84,1.799,1.382,3,1.382h1c.347,0,.678-.058,1-.142v11.142c.006,1.308,1.995,1.307,2,0V10.618c.648-.754,1.122-1.826,.962-2.893Zm-10.962,9.275H3v-5.142c.322,.084,.653,.142,1,.142h1c1.2,0,2.266-.542,3-1.382,.734,.84,1.8,1.382,3,1.382h2v5Z"
            }
        ]
    },
    SoftwareKey: { // Icon updated with new SVG data
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m20.132 14.985c-.34.182-.887.386-1.632.386-.679 0-1.364-.278-1.713-.444-1.385-.691-5.788-3.256-5.788-7.926v-3.477c0-1.417.678-2.712 1.773-3.524h-7.772c-2.757 0-5 2.243-5 5v9c0 2.757 2.243 5 5 5h6v3h-4c-.553 0-1 .447-1 1s.447 1 1 1h10c.553 0 1-.447 1-1s-.447-1-1-1h-4v-3h6c2.757 0 5-2.243 5-5v-1.741c-1.345 1.52-3.021 2.369-3.868 2.726zm-13.132-7.985c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm3.351 8.937c-.504.192-1.094-.063-1.287-.586-.303-.808-1.132-1.351-2.063-1.351s-1.761.543-2.063 1.351c-.193.519-.773.778-.586-1.287-.518-.194-.779-.771-.586-1.287.594-1.585 2.176-2.649 3.937-2.649s3.343 1.064 3.937 2.649c.193.517-.068 1.093-.586 1.287zm7.297-2.816s.525.25.853.25c.501 0 .745-.184.745-.184 1.115-.449 4.754-2.218 4.754-6.187v-3.477c0-1.029-.658-1.94-1.637-2.265l-3.392-1.124c-.306-.102-.636-.102-.943 0l-3.394 1.124c-.978.326-1.635 1.237-1.635 2.266v3.477c0 3.522 3.56 5.576 4.648 6.12zm-1.619-8.959c.162-.983 1.087-1.662 2.084-1.662h.776c.997 0 1.922.679 2.084 1.662.206 1.252-.758 2.338-1.972 2.338v3h.5c.276 0 .5.224.5.5s-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5v-3.5c-1.214 0-2.178-1.086-1.972-2.338zm.972.324c0-.551.449-1 1-1h1c.551 0 1 .449 1 1s-.449 1-1 1h-1c-.551 0-1-.449-1-1z"
            }
        ]
    },
    Key: { // Icon updated with new SVG data
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m15.989 12.7v-2.7a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h2.685a1.016 1.016 0 0 0 .922-.6 4.522 4.522 0 0 0 .376-2.377 3.491 3.491 0 0 0 -3.506-3.023 4.537 4.537 0 0 0 -3.208 1.329l-7.908 7.906a7.368 7.368 0 0 0 -3.881.048 7.5 7.5 0 0 0 2.036 14.717 7.654 7.654 0 0 0 .784-.041 7.529 7.529 0 0 0 6.428-5.429 7.334 7.334 0 0 0 .047-3.88l.65-.65a1.984 1.984 0 0 0 .575-1.3zm-10.489 7.3a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1 -1.5 1.5z"
            }
        ]
    },
    Unlock: { // A descriptive name for the new icon
        width: "24", // As requested
        height: "24", // As requested
        viewBox: "0 0 24 24", // From the source SVG
        paths: [
            {
                d: "M362.705,170.744H149.372v-21.333c-0.016-58.91,47.727-106.68,106.637-106.696c38.815-0.011,74.572,21.064,93.363,55.027 c5.72,10.303,18.71,14.019,29.013,8.299c10.303-5.72,14.019-18.71,8.299-29.013c-39.949-72.153-130.826-98.26-202.98-58.311 c-47.529,26.315-77.017,76.367-76.999,130.695v30.379c-38.826,16.945-63.944,55.259-64,97.621v128 c0.071,58.881,47.786,106.596,106.667,106.667h213.333c58.881-0.07,106.596-47.786,106.667-106.667v-128 C469.301,218.529,421.586,170.814,362.705,170.744z M277.372,362.744c0,11.782-9.551,21.333-21.333,21.333 s-21.333-9.551-21.333-21.333v-42.667c0-11.782,9.551-21.333,21.333-21.333s21.333,9.551,21.333,21.333V362.744z",
                // Scaling the icon down to fit the desired 24x24 viewport
                transform: "scale(0.046875)"
            }
        ]
    },
    Lock: { // A descriptive name for the new icon
        width: "24", // As requested
        height: "24", // As requested
        viewBox: "0 0 24 24", // From the source SVG
        paths: [
            {
                d: "M405.333,179.712v-30.379C405.333,66.859,338.475,0,256,0S106.667,66.859,106.667,149.333v30.379 c-38.826,16.945-63.944,55.259-64,97.621v128C42.737,464.214,90.452,511.93,149.333,512h213.333 c58.881-0.07,106.596-47.786,106.667-106.667v-128C469.278,234.971,444.159,196.657,405.333,179.712z M277.333,362.667 c0,11.782-9.551,21.333-21.333,21.333c-11.782,0-21.333-9.551-21.333-21.333V320c0-11.782,9.551-21.333,21.333-21.333 c11.782,0,21.333,9.551,21.333,21.333V362.667z M362.667,170.667H149.333v-21.333c0-58.91,47.756-106.667,106.667-106.667 s106.667,47.756,106.667,106.667V170.667z",
                // Scaling the icon down to fit the desired 24x24 viewport
                transform: "scale(0.046875)"
            }
        ]
    },
    CancelLicense: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L13.41 12l3.18 3.18c.39.39.39 1.02 0 1.41-.39.39-1.02.39-1.41 0L12 13.41l-3.18 3.18c-.39.39-1.02.39-1.41 0-.39-.39-.39-1.02 0-1.41L10.59 12 7.41 8.82c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L12 10.59l3.18-3.18c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41z",
                transform: "translate(12, 12) scale(1.2) translate(-12, -12)"
            }
        ]
    },
    Blocked: { // A descriptive name for the new icon
        width: "24", // As requested
        height: "24", // As requested
        viewBox: "0 0 24 24", // From the source SVG
        paths: [
            {
                d: "M256,512c141.385,0,256-114.615,256-256S397.385,0,256,0S0,114.615,0,256C0.153,397.322,114.678,511.847,256,512z M469.333,256c0.1,117.726-95.256,213.243-212.982,213.343c-49.313,0.042-97.116-17.016-135.263-48.266l299.989-299.989 C452.315,159.106,469.373,206.795,469.333,256z M256,42.667c49.205-0.039,96.894,17.019,134.912,48.256L90.923,390.912 c-74.604-91.07-61.256-225.375,29.814-299.98C158.884,59.682,206.687,42.625,256,42.667z",
                // Scaling the icon down to fit the desired 24x24 viewport
                transform: "scale(0.046875)"
            }
        ]
    },

    Unblocked: { // A descriptive name for the new icon
        width: "24", // As requested
        height: "24", // As requested
        viewBox: "0 0 24 24", // From the source SVG
        paths: [
            {
                d: "M18,12c-3.309,0-6,2.691-6,6s2.691,6,6,6,6-2.691,6-6-2.691-6-6-6Zm4,6c0,.74-.215,1.424-.567,2.019l-5.453-5.452c.595-.351,1.28-.567,2.019-.567,2.206,0,4,1.794,4,4Zm-8,0c0-.74,.215-1.424,.567-2.019l5.453,5.452c-.595,.351-1.28,.567-2.019,.567-2.206,0-4-1.794-4-4Zm-4,0c0,1.941,.692,3.72,1.842,5.105-.808,.561-1.785,.895-2.842,.895H5c-2.757,0-5-2.243-5-5v-6c0-2.757,2.243-5,5-5h5.5c1.379,0,1.49-.449,1.499-.886-.043-2.614-1.917-4.789-4.392-5.079-2.357-.275-4.54,1.081-5.323,3.298-.185,.52-.757,.793-1.276,.609-.521-.184-.793-.755-.609-1.276C1.495,1.564,4.547-.341,7.839,.049c3.407,.398,6.002,3.307,6.154,6.832,.002,.015,.003,1.912,.004,4.2-2.388,1.384-3.997,3.961-3.997,6.919Z"
            }
        ]
    },
    CalendarRefresh: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M.307,6.221c-.397-.383-.41-1.016-.027-1.414,.382-.399,1.015-.411,1.414-.028l1.307,1.256v-2.035C3,1.794,4.794,0,7,0h1c.553,0,1,.448,1,1s-.447,1-1,1h-1c-1.103,0-2,.897-2,2v2.029l1.307-1.25c.399-.383,1.032-.371,1.414,.028,.383,.398,.37,1.031-.027,1.414l-2.301,2.212c-.38,.378-.883,.569-1.388,.569-.51,0-1.021-.193-1.41-.582L.307,6.221Zm-.307,14.779c0,1.654,1.346,3,3,3h7c1.654,0,3-1.346,3-3v-4H0v4ZM21,0h-7c-1.654,0-3,1.346-3,3h13c0-1.654-1.346-3-3-3ZM11,9c0,1.654,1.346,3,3,3h7c1.654,0,3-1.346,3-3V5H11v4Zm-.972,3.003c-.01,0-.018-.003-.028-.003H3c-1.654,0-3,1.346-3,3H13c0-.417-.086-.813-.239-1.174-1.108-.285-2.061-.937-2.733-1.823Zm11.377,3.577c-.774-.772-2.035-.775-2.798-.013l-2.301,2.212c-.397,.383-.41,1.016-.027,1.414,.383,.397,1.015,.411,1.414,.027l1.307-1.25v2.029c0,1.103-.897,2-2,2h-2c-.553,0-1,.447-1,1s.447,1,1,1h2c2.206,0,4-1.794,4-4v-2.035l1.307,1.256c.194,.187,.444,.279,.693,.279,.263,0,.524-.103,.721-.307,.383-.398,.37-1.031-.027-1.414l-2.288-2.199Z"
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    /* …other icons… */

    CalendarCheck: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M19,2h-1V1c0-.552-.447-1-1-1s-1,.448-1,1v1H8V1c0-.552-.447-1-1-1s-1,.448-1,1v1h-1C2.243,2,0,4.243,0,7v12c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V7c0-2.757-2.243-5-5-5ZM5,4h14c1.654,0,3,1.346,3,3v1H2v-1c0-1.654,1.346-3,3-3Zm14,18H5c-1.654,0-3-1.346-3-3V10H22v9c0,1.654-1.346,3-3,3Zm-1.168-8.848c.384,.397,.372,1.031-.025,1.414l-4.74,4.568c-.553,.553-1.307,.866-2.108,.866s-1.555-.312-2.121-.879l-2.252-2.092c-.404-.376-.428-1.009-.052-1.413,.378-.405,1.01-.427,1.413-.052l2.278,2.117c.433,.43,1.063,.402,1.439,.026l4.754-4.582c.398-.383,1.03-.371,1.414,.026Z"
                // Optional styling fields:
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    List: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M24 12c0 .552-.448 1-1 1h-5c-.552 0-1-.448-1-1s.448-1 1-1h5c.552 0 1 .448 1 1zm-1 8h-5c-.552 0-1 .448-1 1s.448 1 1 1h5c.552 0 1-.448 1-1s-.448-1-1-1zm-13-16h13c.552 0 1-.448 1-1s-.448-1-1-1h-13c-.552 0-1 .448-1 1s.448 1 1 1zm4 7v2c0 1.103-.897 2-2 2h-2c-1.103 0-2-.897-2-2h-4v5c0 1.103.897 2 2 2h2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2h-2c-1.103 0-2-.897-2-2h-2c-2.206 0-4-1.794-4-4v-12c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2v5h4c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2z"
                // Optional extras for consistency:
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    Sync: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M23.68,16.73l-2.59,2.41c-.54,.54-1.3,.85-2.1,.85s-1.55-.31-2.12-.88l-2.56-2.39c-.4-.38-.43-1.01-.05-1.41,.38-.4,1.01-.42,1.41-.05l2.32,2.16V9c0-1.65-1.35-3-3-3h-4c-.55,0-1-.45-1-1s.45-1,1-1h4c2.76,0,5,2.24,5,5v8.43l2.32-2.16c.4-.38,1.04-.35,1.41,.05,.38,.4,.35,1.04-.05,1.41Zm-10.68,1.27h-4c-1.65,0-3-1.35-3-3V6.57l2.32,2.16c.19,.18,.44,.27,.68,.27,.27,0,.53-.11,.73-.32,.38-.4,.35-1.04-.05-1.41l-2.56-2.39c-1.13-1.13-3.13-1.11-4.22-.02L.32,7.27c-.4,.38-.43,1.01-.05,1.41,.38,.41,1.01,.43,1.41,.05l2.32-2.16V15c0,2.76,2.24,5,5,5h4c.55,0,1-.45,1-1s-.45-1-1-1Z"
                // Optional styling properties:
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    Tag: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M7.707,9.293c.391,.391,.391,1.024,0,1.414-.391,.391-1.024,.391-1.414,0-.391-.391-.391-1.024,0-1.414,.391-.391,1.024-.391,1.414,0Zm14.473,3.631l-1.24,1.281c.187,.884-.06,1.842-.745,2.527l-6.244,6.449c-.532,.532-1.225,.819-1.962,.819s-1.43-.287-1.95-.808L1.025,14.18,2.034,5.057l9.137-1.25,8.663,8.663,.92-.95c.308-.307,.308-.788,.012-1.084L12.435,2.107l-7.255,.937-.256-1.983L13.153-.002l9.026,9.026c1.075,1.075,1.075,2.825,0,3.901Zm-3.399,1.321L10.458,5.924l-6.607,.904-.731,6.617,8.333,8.333c.287,.287,.785,.287,1.072,0l6.244-6.449c.308-.307,.308-.788,.012-1.084Z"
                // Optional styling props:
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    userSettings: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M9,12c-3.309,0-6-2.691-6-6S5.691,0,9,0s6,2.691,6,6-2.691,6-6,6Zm13.696,7.134l-.974-.562c.166-.497,.278-1.019,.278-1.572s-.111-1.075-.278-1.572l.974-.562c.478-.276,.642-.888,.366-1.366-.277-.479-.887-.644-1.366-.366l-.973,.562c-.705-.794-1.644-1.375-2.723-1.594v-1.101c0-.552-.448-1-1-1s-1,.448-1,1v1.101c-1.079,.22-2.018,.801-2.723,1.594l-.973-.562c-.48-.277-1.09-.113-1.366,.366-.276,.479-.112,1.09,.366,1.366l.974,.562c-.166,.497-.278,1.019-.278,1.572s.111,1.075,.278,1.572l-.974,.562c-.478,.276-.642,.888-.366,1.366,.186,.321,.521,.5,.867,.5,.169,0,.341-.043,.499-.134l.973-.562c.705,.794,1.644,1.375,2.723,1.594v1.101c0,.552,.448,1,1,1s1-.448,1-1v-1.101c1.079-.22,2.018-.801,2.723-1.594l.973,.562c.158,.091,.33,.134,.499,.134,.346,0,.682-.179,.867-.5,.276-.479,.112-1.09-.366-1.366Zm-5.696-.634c-.827,0-1.5-.673-1.5-1.5s.673-1.5,1.5-1.5,1.5,.673,1.5,1.5-.673,1.5-1.5,1.5Zm-9-1.5c0-1.044,.187-2.043,.514-2.975C3.778,14.279,0,18.202,0,23c0,.552,.448,1,1,1H11.349c-2.041-1.65-3.349-4.171-3.349-7Z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    Cloud: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M17.792,7.212A8,8,0,0,0,2,9a7.915,7.915,0,0,0,.9,3.671A5.49,5.49,0,0,0,5.5,23H16A8,8,0,0,0,17.792,7.212Z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    cloudOff: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m23.707 22.293a1 1 0 1 1 -1.414 1.414l-22-22a1 1 0 0 1 1.414-1.414l2.87 2.87a7.871 7.871 0 0 1 4.237-2.078 7.985 7.985 0 0 1 8.82 5.541 1.088 1.088 0 0 0 .722.735 7.96 7.96 0 0 1 5.62 8.277 7.379 7.379 0 0 1 -2.2 4.729zm-20.266-14.63a.811.811 0 0 0 -1.379.464 7.286 7.286 0 0 0 -.062.912 7.422 7.422 0 0 0 .941 3.609 5.443 5.443 0 0 0 -2.884 5.652 5.843 5.843 0 0 0 5.626 4.7h9.1a11.87 11.87 0 0 0 1.952-.158.839.839 0 0 0 .462-1.42z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    Copy: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M21.155,3.272,18.871.913A3.02,3.02,0,0,0,16.715,0H12A5.009,5.009,0,0,0,7.1,4H7A5.006,5.006,0,0,0,2,9V19a5.006,5.006,0,0,0,5,5h6a5.006,5.006,0,0,0,5-5v-.1A5.009,5.009,0,0,0,22,14V5.36A2.988,2.988,0,0,0,21.155,3.272ZM13,22H7a3,3,0,0,1-3-3V9A3,3,0,0,1,7,6v8a5.006,5.006,0,0,0,5,5h4A3,3,0,0,1,13,22Zm4-5H12a3,3,0,0,1-3-3V5a3,3,0,0,1,3-3h4V4a2,2,0,0,0,2,2h2v8A3,3,0,0,1,17,17Z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    erase: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m7.235,7.42l4.971-4.953c.943-.946,2.201-1.468,3.54-1.468s2.596.522,3.541,1.47l3.254,3.265c1.939,1.946,1.939,5.113,0,7.06l-4.972,4.991L7.235,7.42Zm15.765,13.58h-8.633l1.791-1.798L5.818,8.832,1.459,13.175c-1.939,1.946-1.939,5.113,0,7.059l1.583,1.589c.745.748,1.777,1.177,2.834,1.177h17.124c.553,0,1-.448,1-1s-.447-1-1-1Z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    erase2: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M12.836,.028C9.356-.207,5.961,1.067,3.509,3.521,1.057,5.977-.211,9.378,.029,12.854c.441,6.354,6.053,11.146,13.054,11.146h5.917c2.757,0,5-2.243,5-5v-6.66C24,5.861,19.097,.454,12.836,.028Zm2.871,14.265c.391,.391,.391,1.023,0,1.414-.195,.195-.451,.293-.707,.293s-.512-.098-.707-.293l-2.293-2.293-2.293,2.293c-.195,.195-.451,.293-.707,.293s-.512-.098-.707-.293c-.391-.391-.391-1.023,0-1.414l2.293-2.293-2.293-2.293c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l2.293,2.293,2.293-2.293c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414l-2.293,2.293,2.293,2.293Z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    erase3: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M15.707,9.707l-2.293,2.293,2.293,2.293c.391,.391,.391,1.023,0,1.414-.195,.195-.451,.293-.707,.293s-.512-.098-.707-.293l-2.293-2.293-2.293,2.293c-.195,.195-.451,.293-.707,.293s-.512-.098-.707-.293c-.391-.391-.391-1.023,0-1.414l2.293-2.293-2.293-2.293c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l2.293,2.293,2.293-2.293c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414Zm8.293,2.633v6.66c0,2.757-2.243,5-5,5h-5.917C6.082,24,.471,19.208,.029,12.854-.211,9.378,1.057,5.977,3.509,3.521,5.961,1.067,9.356-.207,12.836,.028c6.261,.426,11.164,5.833,11.164,12.312Zm-2,0c0-5.431-4.085-9.962-9.299-10.315-.229-.016-.458-.023-.686-.023-2.656,0-5.21,1.049-7.092,2.934-2.043,2.046-3.1,4.882-2.898,7.781,.372,5.38,5.023,9.284,11.058,9.284h5.917c1.654,0,3-1.346,3-3v-6.66Z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    gear: {
        width: 24,
        height: 24,
        viewBox: "0 0 512 512",
        paths: [
            {
                d: "M34.283,384c17.646,30.626,56.779,41.148,87.405,23.502c0.021-0.012,0.041-0.024,0.062-0.036l9.493-5.483   c17.92,15.332,38.518,27.222,60.757,35.072V448c0,35.346,28.654,64,64,64s64-28.654,64-64v-10.944   c22.242-7.863,42.841-19.767,60.757-35.115l9.536,5.504c30.633,17.673,69.794,7.167,87.467-23.467   c17.673-30.633,7.167-69.794-23.467-87.467l0,0l-9.472-5.461c4.264-23.201,4.264-46.985,0-70.187l9.472-5.461   c30.633-17.673,41.14-56.833,23.467-87.467c-17.673-30.633-56.833-41.14-87.467-23.467l-9.493,5.483   C362.862,94.638,342.25,82.77,320,74.944V64c0-35.346-28.654-64-64-64s-64,28.654-64,64v10.944   c-22.242,7.863-42.841,19.767-60.757,35.115l-9.536-5.525C91.073,86.86,51.913,97.367,34.24,128s-7.167,69.794,23.467,87.467l0,0   l9.472,5.461c-4.264,23.201-4.264,46.985,0,70.187l-9.472,5.461C27.158,314.296,16.686,353.38,34.283,384z M256,170.667   c47.128,0,85.333,38.205,85.333,85.333S303.128,341.333,256,341.333S170.667,303.128,170.667,256S208.872,170.667,256,170.667z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    backBurger: {
        width: 19.82,
        height: 12.84,
        viewBox: "0 0 19.82 12.84",
        paths: [
            {
                d: "M5,13l4,4L7.6,18.42,1.18,12,7.6,5.58,9,7,5,11H21v2H5M21,6V8H11V6H21m0,10v2H11V16Z",
                transform: "translate(-1.18 -5.58)",
                // fill: "#e84e0f",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    closeCircle: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m15.707,9.707l-2.293,2.293,2.293,2.293c.391.391.391,1.023,0,1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-2.293-2.293-2.293,2.293c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023,0-1.414l2.293-2.293-2.293-2.293c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l2.293,2.293,2.293-2.293c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414Zm8.293,2.293c0,6.617-5.383,12-12,12S0,18.617,0,12,5.383,0,12,0s12,5.383,12,12Zm-2,0c0-5.514-4.486-10-10-10S2,6.486,2,12s4.486,10,10,10,10-4.486,10-10Z",
                // stroke: "currentColor",
                // strokeWidth: 1.5,
            },
        ],
    },
    userDollar: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m5,6C5,2.691,7.691,0,11,0s6,2.691,6,6-2.691,6-6,6-6-2.691-6-6Zm16.685,10.267l-3.041-.507c-.373-.062-.644-.382-.644-.76,0-.551.448-1,.999-1l2.271.003c.36,0,.684.187.866.5.276.477.89.64,1.367.362.478-.277.64-.89.361-1.367-.536-.922-1.53-1.495-2.594-1.495h-.271v-1.003c0-.552-.447-1-1-1s-1,.448-1,1v1c-1.654,0-3,1.346-3,3,0,1.36.974,2.51,2.315,2.733l3.041.507c.373.062.644.382.644.76,0,.551-.448,1-.999,1l-2.27-.002c-.356,0-.688-.191-.866-.499-.276-.478-.889-.64-1.366-.364-.479.277-.642.889-.364,1.367.535.923,1.529,1.496,2.596,1.496h.27v1.002c0,.552.447,1,1,1s1-.448,1-1v-1c1.654,0,3-1.346,3-3,0-1.36-.974-2.51-2.315-2.733Zm-7.28,5.238c-.402-.693-.51-1.502-.304-2.277.145-.541.43-1.02.824-1.396-.585-.795-.925-1.776-.925-2.832,0-.157.032-.305.046-.458-.953-.344-1.976-.542-3.046-.542-4.963,0-9,4.038-9,9,0,.552.447,1,1,1h14.184c-.034-.095-.066-.191-.09-.291-1.114-.389-2.082-1.156-2.69-2.205Z",
            },
        ],
    },
    circleDollar: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m11,18v-1h-.268c-1.067,0-2.063-.574-2.598-1.499-.276-.479-.113-1.09.365-1.366.477-.278,1.089-.114,1.366.364.179.31.511.501.867.501h2.268c.552,0,1-.448,1-1,0-.379-.271-.698-.645-.761l-3.04-.506c-1.342-.224-2.315-1.374-2.315-2.733,0-1.654,1.346-3,3-3v-1c0-.553.448-1,1-1s1,.447,1,1v1h.268c1.067,0,2.063.574,2.598,1.499.277.479.113,1.09-.364,1.366-.48.277-1.092.113-1.366-.364-.179-.31-.511-.501-.867-.501h-2.268c-.551,0-1,.448-1,1,0,.379.271.698.644.761l3.041.506c1.342.224,2.315,1.374,2.315,2.733,0,1.654-1.346,3-3,3v1c0,.553-.448,1-1,1s-1-.447-1-1Zm6-10c0,.553.447,1,1,1h3.991c1.107,0,2.009-.901,2.009-2.009v-3.991c0-.553-.447-1-1-1s-1,.447-1,1l-.005,2.345C19.805,2.034,16.104,0,12,0,5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12c0-.553-.447-1-1-1s-1,.447-1,1c0,5.514-4.486,10-10,10S2,17.514,2,12,6.486,2,12,2c3.64,0,6.901,1.921,8.666,5h-2.666c-.553,0-1,.447-1,1Z",
            },
        ],
    },
    download: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M210.731,386.603c24.986,25.002,65.508,25.015,90.51,0.029c0.01-0.01,0.019-0.019,0.029-0.029l68.501-68.501c7.902-8.739,7.223-22.23-1.516-30.132c-8.137-7.357-20.527-7.344-28.649,0.03l-62.421,62.443l0.149-329.109C277.333,9.551,267.782,0,256,0c-11.782,0-21.333,9.551-21.333,21.333l-0.192,328.704L172.395,288c-8.336-8.33-21.846-8.325-30.176,0.011c-8.33,8.336-8.325,21.846,0.011,30.176L210.731,386.603z",
                fill: "currentColor",
                transform: "scale(0.046875)"
            },
            {
                d: "M490.667,341.333c-11.782,0-21.333,9.551-21.333,21.333V448c0,11.782-9.551,21.333-21.333,21.333H64c-11.782,0-21.333-9.551-21.333-21.333v-85.333c0-11.782-9.551-21.333-21.333-21.333C9.551,341.333,0,350.885,0,362.667V448c0,35.346,28.654,64,64,64h384c35.346,0,64-28.654,64-64v-85.333c0-11.782-9.551-21.333-21.333-21.333z",
                fill: "currentColor",
                transform: "scale(0.046875)"
            }
        ]
    },
    filePdf: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M7.98,16.11c0,.47-.41,.86-.89,.86h-.83v-1.72h.84c.48,0,.89,.39,.89,.86Zm7.02-8.11h6.54c-.35-.91-.88-1.75-1.59-2.46l-3.48-3.49c-.71-.71-1.55-1.24-2.46-1.59V7c0,.55,.45,1,1,1Zm-2.91,7.25h-.84v3.5h.84c.48,0,.89-.39,.89-.86v-1.78c0-.47-.41-.86-.89-.86Zm9.91-4.76v8.51c0,2.76-2.24,5-5,5H7c-2.76,0-5-2.24-5-5V5C2,2.24,4.24,0,7,0h4.51c.16,0,.32,.01,.49,.02V7c0,1.65,1.35,3,3,3h6.98c.01,.16,.02,.32,.02,.49Zm-12.77,5.62c0-1.16-.96-2.11-2.14-2.11h-1.09c-.55,0-1,.45-1,1v4.44c0,.35,.28,.62,.62,.62s.62-.28,.62-.62v-1.22h.84c1.18,0,2.14-.95,2.14-2.11Zm5,0c0-1.16-.96-2.11-2.14-2.11h-1.09c-.55,0-1,.45-1,1v4.44c0,.35,.28,.56,.62,.56h1.46c1.18,0,2.14-.95,2.14-2.11Zm4.79-1.48c0-.35-.28-.62-.62-.62h-2.31c-.35,0-.62,.28-.62,.62v4.81c0,.35,.28,.62,.62,.62s.62-.28,.62-.62v-1.8h1.24c.35,0,.62-.28,.62-.62s-.28-.62-.62-.62h-1.24v-1.14h1.69c.35,0,.62-.28,.62-.62Z",
                fill: "currentColor"
            }
        ]
    },
    fileImage: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m14,7V.46c.913.346,1.753.879,2.465,1.59l3.484,3.486c.712.711,1.245,1.551,1.591,2.464h-6.54c-.552,0-1-.449-1-1Zm-4.938,8.024c1.344-1.345,3.532-1.345,4.876,0l.615.615c.522.521,1.371.521,1.894,0l5.535-5.535c-.002-.035-.003-.07-.005-.104h-6.976c-1.654,0-3-1.346-3-3V.024c-.161-.011-.322-.024-.485-.024h-4.515C4.243,0,2,2.243,2,5v14c0,.886.251,1.707.657,2.429l6.405-6.405Zm-1.562-6.024c.828,0,1.5.672,1.5,1.5s-.672,1.5-1.5,1.5-1.5-.672-1.5-1.5.672-1.5,1.5-1.5Zm10.361,8.053c-1.302,1.302-3.42,1.302-4.722,0l-.615-.615c-.564-.564-1.483-.564-2.048,0l-6.509,6.509c.844.65,1.888,1.053,3.033,1.053h10c2.757,0,5-2.243,5-5v-6.086l-4.139,4.139Z",
                fill: "currentColor"
            }
        ]
    },
    folderOpen: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m0,18V5C0,2.794,1.794,1,4,1h2c.464,0,.928.109,1.342.316l3.155,1.578c.138.069.293.105.447.105h5.056c2.757,0,5,2.243,5,5h-10.976c-2.638,0-5.003,1.766-5.754,4.303l-2.673,9.339c-.977-.913-1.597-2.203-1.597-3.642Zm23.493-6.983c-.479-.643-1.209-1.012-2.008-1.025-.015,0-.027.008-.042.008h-11.419c-1.758,0-3.335,1.177-3.834,2.862l-2.818,9.843c.513.178,1.055.295,1.628.295h12.558c2.226,0,4.15-1.432,4.802-3.607l1.532-6.116c.234-.782.089-1.605-.398-2.26Z",
                fill: "currentColor"
            }
        ]
    },
    fileText: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m14 7v-6.54a6.977 6.977 0 0 1 2.465 1.59l3.484 3.486a6.954 6.954 0 0 1 1.591 2.464h-6.54a1 1 0 0 1 -1-1zm8 3.485v8.515a5.006 5.006 0 0 1 -5 5h-10a5.006 5.006 0 0 1 -5-5v-14a5.006 5.006 0 0 1 5-5h4.515c.163 0 .324.013.485.024v6.976a3 3 0 0 0 3 3h6.976c.011.161.024.322.024.485zm-8 8.515a1 1 0 0 0 -1-1h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 1-1zm3-4a1 1 0 0 0 -1-1h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1z",
                fill: "currentColor"
            }
        ]
    },
    fileExcel: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M14,7V.46c.913,.346,1.753,.879,2.465,1.59l3.484,3.486c.712,.711,1.245,1.551,1.591,2.464h-6.54c-.552,0-1-.449-1-1Zm7.976,3h-6.976c-1.654,0-3-1.346-3-3V.024c-.161-.011-.322-.024-.485-.024H7C4.243,0,2,2.243,2,5v14c0,2.757,2.243,5,5,5h10c2.757,0,5-2.243,5-5V10.485c0-.163-.013-.324-.024-.485Zm-12.259,8.835c.269,.539-.123,1.173-.726,1.173-.307,0-.589-.174-.726-.449l-.864-1.733-.864,1.733c-.137,.275-.418,.449-.726,.449h0c-.602,0-.994-.634-.726-1.173l1.409-2.827-1.409-2.827c-.269-.539,.123-1.173,.726-1.173,.307,0,.589,.174,.726,.449l.864,1.733,.864-1.733c.137-.275,.418-.449,.726-.449,.602,0,.994,.634,.726,1.173l-1.409,2.827,1.409,2.827Zm4.019,1.173h-2.133c-.442,0-.8-.358-.8-.8v-6.401c0-.442,.358-.8,.8-.8h0c.442,0,.8,.358,.8,.8v5.601s.578,0,1.333,0c.442,0,.8,.358,.8,.8s-.358,.8-.8,.8Zm6.235-2.028c-.191,1.175-1.215,2.028-2.436,2.028-.664,0-1.301-.196-1.84-.553-.387-.257-.447-.801-.118-1.129l.002-.002c.236-.235,.602-.283,.886-.11,.316,.191,.689,.298,1.07,.298,.604,0,1.031-.404,1.096-.795,.088-.55-.602-.873-.817-.959-.915-.371-1.751-.78-1.753-.78-.692-.484-1.027-1.231-.921-2.049,.111-.845,.674-1.534,1.471-1.796,.839-.277,1.603-.076,2.152,.203,.405,.205,.518,.733,.24,1.093-.203,.263-.559,.358-.863,.225-.306-.134-.71-.226-1.137-.088-.412,.136-.517,.447-.515,.577,.005,.442,.335,.57,.433,.615,.282,.128,.806,.368,1.366,.595,1.461,.591,1.828,1.745,1.685,2.627Z",
                fill: "currentColor"
            }
        ]
    },
    presentation: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M14,23h0c0,.55-.45,1-1,1H1c-.55,0-1-.45-1-1H0c0-3.87,3.13-7,7-7h0c3.87,0,7,3.13,7,7Zm-3-13c0-2.21-1.79-4-4-4s-4,1.79-4,4,1.79,4,4,4,4-1.79,4-4ZM19,0H9c-2.69,0-4.87,2.14-4.98,4.8,.88-.51,1.89-.8,2.98-.8,2.74,0,5.04,1.84,5.76,4.35l2.24,2.24,3.59-3.59h-1.59c-.55,0-1-.45-1-1s.45-1,1-1h3c1.1,0,2,.9,2,2v3c0,.55-.45,1-1,1s-1-.45-1-1v-1.59l-3.59,3.59c-.78,.78-2.05,.78-2.83,0l-.72-.72s0,.01,0,.02c-.31,1.41-1.12,2.63-2.23,3.47,1.57,.69,2.9,1.82,3.85,3.23h4.53c2.76,0,5-2.24,5-5V5c0-2.76-2.24-5-5-5Z",
                fill: "currentColor"
            }
        ]
    },
    Video: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M8,20c1.105,0,2,.895,2,2s-.895,2-2,2-2-.895-2-2,.895-2,2-2Zm2.36-13.463c-.188-.095-.4,.006-.412,.243v4.441c.023,.235,.196,.337,.412,.243l3.997-2.221c.2-.138,.2-.348,0-.485l-3.997-2.221Zm13.64-1.537V13c0,2.757-2.243,5-5,5H5c-2.757,0-5-2.243-5-5V5C0,2.243,2.243,0,5,0h14c2.757,0,5,2.243,5,5Zm-7.5,4c0-.826-.449-1.589-1.171-1.991l-3.997-2.221c-1.444-.867-3.44,.307-3.384,1.991v4.441c-.057,1.684,1.94,2.857,3.384,1.991l3.998-2.221c.722-.402,1.171-1.165,1.171-1.991Zm7.5,13c0-.553-.448-1-1-1H13c-.552,0-1,.447-1,1s.448,1,1,1h10c.552,0,1-.447,1-1Zm-20,0c0-.553-.448-1-1-1H1c-.552,0-1,.447-1,1s.448,1,1,1H3c.552,0,1-.447,1-1Z"
            }
        ]
    },
    Audio: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m21 12.424v-1.424c0-4.962-4.037-9-9-9s-9 4.038-9 9v1.424c-1.763.774-3 2.531-3 4.576 0 2.757 2.243 5 5 5 .97 0 2-.701 2-2v-6c0-1.299-1.03-2-2-2v-1c0-3.86 3.141-7 7-7s7 3.14 7 7v1c-.97 0-2 .701-2 2v6c0 1.299 1.03 2 2 2 2.757 0 5-2.243 5-5 0-2.045-1.237-3.802-3-4.576zm-5 4.576c0 .477-.334.875-.78.976l-1.339 2.497c-.187.353-.572.558-.966.524-.398-.034-.737-.302-.863-.68l-1.237-3.71-.42.841c-.17.339-.516.553-.895.553h-.5c-.553 0-1-.448-1-1 0-.511.384-.933.878-.993l1.228-2.455c.181-.361.552-.576.966-.55.403.029.749.298.877.681l1.267 3.799.513-.955c.174-.325.513-.527.881-.527h.392c.553 0 1 .448 1 1z"
            }
        ]
    },
    Folder: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [{ d: "M10,4H4C2.895,4,2,4.895,2,6v12c0,1.105,0.895,2,2,2h16c1.105,0,2-0.895,2-2V8c0-1.105-0.895-2-2-2h-8L10,4z" }]
    },
    File: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [{ d: "M6,2c-1.105,0-2,0.895-2,2v16c0,1.105,0.895,2,2,2h12c1.105,0,2-0.895,2-2V8l-6-6H6z M13,9V3.5L18.5,9H13z" }]
    },
    zipFile: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m13.729,5.955c0,.398-.349.735-.762.735l-.71.003-.005-1.473h.715c.413,0,.762.336.762.735Zm4.271,13.045v4.54c.913-.347,1.753-.879,2.465-1.591l1.484-1.485c.712-.711,1.245-1.551,1.591-2.465h-4.54c-.552,0-1,.449-1,1Zm6-14v10.515c0,.163-.013.324-.024.485h-4.976c-1.654,0-3,1.346-3,3v4.976c-.161.011-.322.024-.485.024H5c-2.757,0-5-2.243-5-5V5C0,2.243,2.243,0,5,0h14c2.757,0,5,2.243,5,5ZM7.249,9.435c0-.331-.268-.599-.599-.599h-1.695l2.163-3.47c.167-.267.175-.605.022-.88-.153-.275-.444-.446-.759-.446h-2.282c-.331,0-.599.269-.599.599s.268.599.599.599h1.686l-2.151,3.452c-.169.271-.178.613-.023.892.155.279.45.452.769.452h2.27c.331,0,.599-.269.599-.599Zm2.449-4.797c0-.331-.268-.599-.599-.599s-.599.269-.599.599v4.8c0,.331.268.599.599.599s.599-.269.599-.599v-4.8Zm5.28,1.317c0-1.094-.902-1.985-2.012-1.985h-1.342c-.345,0-.625.28-.625.625v4.819c0,.345.28.625.625.625s.625-.28.625-.625v-1.471l.717-.003c1.109,0,2.012-.891,2.012-1.985Z"
            }
        ]
    },
    fileDocx: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M21.98,10h-6.98c-1.65,0-3-1.35-3-3V.02c-.16-.01-.32-.02-.49-.02H7C4.24,0,2,2.24,2,5v14c0,2.76,2.24,5,5,5h10c2.76,0,5-2.24,5-5V10.49c0-.16-.01-.32-.02-.49Zm-5.26,4.24l-1.42,5.66c-.15,.61-.68,1.05-1.31,1.09-.63,.04-1.21-.32-1.44-.91l-.55-1.38-.55,1.38c-.22,.56-.75,.91-1.34,.91-.03,0-.07,0-.1,0-.63-.04-1.15-.48-1.31-1.1l-1.41-5.66c-.13-.54,.19-1.08,.73-1.21,.53-.13,1.08,.19,1.21,.73l1,4,.85-2.13c.15-.38,.52-.63,.93-.63h0c.41,0,.78,.25,.93,.63l.84,2.13,1.01-4c.13-.54,.68-.86,1.21-.73,.54,.13,.86,.68,.73,1.21Zm-2.72-7.24V.46c.91,.35,1.75,.88,2.46,1.59l3.48,3.49c.71,.71,1.24,1.55,1.59,2.46h-6.54c-.55,0-1-.45-1-1Z"
            }
        ]
    },

    Save: {
        width: 24,
        height: 24,
        viewBox: "0 0 512 512",
        paths: [
            { d: "M256 341.333c23.564 0 42.667-19.103 42.667-42.667s-19.103-42.667-42.667-42.667-42.667 19.103-42.667 42.667 19.103 42.667 42.667 42.667z" },
            { d: "M480.768 87.936l-56.704-56.704c-5.674-5.585-11.957-10.515-18.731-14.699V64c-.071 58.881-47.786 106.596-106.667 106.667h-85.333C154.452 170.596 106.737 122.881 106.667 64V0C47.786.071.071 47.786 0 106.667v298.667C.071 464.215 47.786 511.93 106.667 512h298.667C464.214 511.93 511.93 464.215 512 405.334V163.35c.08-28.301-11.167-55.457-31.232-75.414zM256 384c-47.128 0-85.333-38.205-85.333-85.333s38.205-85.333 85.333-85.333 85.333 38.205 85.333 85.333S303.128 384 256 384z" },
            { d: "M213.333 128h85.333c35.346 0 64-28.654 64-64V1.366c-4.638-.756-9.32-1.212-14.016-1.365H149.333v64c0 35.346 28.654 64 64 64z" },
        ],
    },
    Copy: {
        width: 24,
        height: 24,
        viewBox: "0 0 512 512",
        paths: [
            { d: "M256 448c-82.436-.094-149.239-66.898-149.333-149.333v-192c0-4.267.277-8.533.64-12.629C68.139 110.864 42.731 149.371 42.667 192v213.333C42.737 464.214 90.452 511.93 149.333 512h128c42.629-.064 81.136-25.473 97.963-64.64-4.267.363-8.363.64-12.629.64H256z" },
            { d: "M451.307 69.803l-48.725-50.325C397.217 14.045 390.924 9.616 384 6.4v78.933h78.08c-2.799-5.683-6.43-10.918-10.773-15.53z" },
            { d: "M362.667 85.333c0 11.782 9.551 21.333 21.333 21.333h84.608c-1.571-13.852-7.65-26.805-17.301-36.864l-48.725-50.325c-10.659-10.804-24.8-17.485-39.915-18.859V85.333z" },
            { d: "M320 85.333V0h-64c-58.881.071-106.596 47.786-106.667 106.667v192c.071 58.881 47.786 106.596 106.667 106.667h106.667c58.881-.071 106.596-47.786 106.667-106.667V149.333H384c-35.346 0-64-28.653-64-64z" },
        ],
    },
    upload: {
        width: 24,
        height: 24,
        viewBox: "0 0 512.008 512.008",
        paths: [
            {
                d: "M172.399 117.448l62.421-62.443-.149 329.344c0 11.782 9.551 21.333 21.333 21.333s21.333-9.551 21.333-21.333l.149-328.981 62.123 62.144c8.475 8.185 21.98 7.951 30.165-.524 7.985-8.267 7.985-21.374 0-29.641L301.273 18.76c-24.986-25.002-65.508-25.015-90.51-.029l-68.501 68.523c-8.185 8.475-7.951 21.98.524 30.165 8.267 7.985 21.374 7.985 29.613.029z",
            },
            {
                d: "M490.671 341.341c-11.782 0-21.333 9.551-21.333 21.333v85.333c0 11.782-9.551 21.333-21.333 21.333h-384c-11.782 0-21.333-9.551-21.333-21.333v-85.333c0-11.782-9.551-21.333-21.333-21.333S0 350.892 0 362.674v85.333c0 35.346 28.654 64 64 64h384c35.346 0 64-28.654 64-64v-85.333c0-11.782-9.551-21.333-21.329-21.333z",
            },
        ],
    },
    monitor: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M19 1H5a5.006 5.006 0 0 0-5 5v8a5.006 5.006 0 0 0 5 5h6v2H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2h-4v-2h6a5.006 5.006 0 0 0 5-5V6a5.006 5.006 0 0 0-5-5Zm0 10h-2.965l-1.7 2.555a1 1 0 0 1-.835.445h-.062a1 1 0 0 1-.833-.551l-2.229-4.461-1.044 1.567a1 1 0 0 1-.832.445h-3.5a1 1 0 0 1 0-2h2.965l1.7-2.555a.987.987 0 0 1 .897-.445 1 1 0 0 1 .833.551l2.229 4.459 1.044-1.567a1 1 0 0 1 .832-.443h3.5a1 1 0 0 1 0 2Z"
            }
        ]
    },
    compact: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M7.293 2.091 5.4 3.985 1.707.293A1 1 0 0 0 .293 1.707L3.985 5.4 2.091 7.293A1 1 0 0 0 2.8 9H7.564A1.436 1.436 0 0 0 9 7.564V2.8A1 1 0 0 0 7.293 2.091Z"
            },
            {
                d: "M20.015 18.6l1.894-1.894A1 1 0 0 0 21.2 15H16.436A1.436 1.436 0 0 0 15 16.436V21.2a1 1 0 0 0 1.707.708L18.6 20.015l3.692 3.692a1 1 0 0 0 1.414-1.414Z"
            },
            {
                d: "M16.436 9H21.2a1 1 0 0 0 .708-1.707L20.015 5.4l3.692-3.692A1 1 0 0 0 22.293.293L18.6 3.985 16.707 2.091A1 1 0 0 0 15 2.8V7.564A1.436 1.436 0 0 0 16.436 9Z"
            },
            {
                d: "M7.564 15H2.8a1 1 0 0 0-.708 1.707L3.985 18.6.293 22.293a1 1 0 1 0 1.414 1.414L5.4 20.015l1.894 1.894A1 1 0 0 0 9 21.2V16.436A1.436 1.436 0 0 0 7.564 15Z"
            }
        ]
    },
    x: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M13.292 12L21.774 1.633c.35-.427.286-1.057-.142-1.407-.428-.348-1.057-.287-1.407.142L12 10.421 3.774.367c-.351-.429-.98-.49-1.407-.142-.428.351-.491.98-.142 1.407L10.708 12 2.226 22.367c-.35.427-.286 1.057.142 1.407.186.151.409.226.632.226.29 0 .577-.125.775-.367L12 13.579l8.226 10.053c.198.242.485.367.775.367.223 0 .446-.074.632-.226.428-.351.491-.98.142-1.407L13.292 12Z"
            }
        ]
    },
    zap: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M11.24,24a2.262,2.262,0,0,1-.948-.212,2.18,2.18,0,0,1-1.2-2.622L10.653,16H6.975A3,3,0,0,1,4.1,12.131l3.024-10A2.983,2.983,0,0,1,10,0h3.693a2.6,2.6,0,0,1,2.433,3.511L14.443,8H17a3,3,0,0,1,2.483,4.684l-6.4,10.3A2.2,2.2,0,0,1,11.24,24Z"
                // No stroke, fill, or other properties specified in the source SVG path element,
                // so we only include 'd'
            }
        ]
    },
    barchart: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M21,15H3c-1.65,0-3-1.35-3-3s1.35-3,3-3H21c1.65,0,3,1.35,3,3s-1.35,3-3,3ZM15,6H3c-1.65,0-3-1.35-3-3S1.35,0,3,0H15c1.65,0,3,1.35,3,3s-1.35,3-3,3Zm-6,18H3c-1.65,0-3-1.35-3-3s1.35-3,3-3h6c1.65,0,3,1.35,3,3s-1.35,3-3,3Z"
            }
        ]
    },
    home: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M19,24H5c-2.757,0-5-2.243-5-5V9.724c0-1.665,.824-3.215,2.204-4.145L9.203,.855c1.699-1.146,3.895-1.146,5.594,0l7,4.724c1.379,.93,2.203,2.479,2.203,4.145v9.276c0,2.757-2.243,5-5,5Z"
            }
        ]
    },
    sum: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m18,24H4.872c-1.15,0-2.155-.653-2.622-1.705-.467-1.051-.277-2.234.495-3.087.032-.036.066-.069.104-.099l8.584-7.108L2.849,4.892c-.037-.03-.071-.063-.104-.099-.772-.853-.962-2.036-.495-3.087.467-1.052,1.472-1.705,2.622-1.705h13.128c2.206,0,4,1.794,4,4v1c0,.552-.447,1-1,1s-1-.448-1-1v-1c0-1.103-.897-2-2-2H4.872c-.524,0-.74.395-.794.516-.052.116-.19.514.111.889l9.448,7.825c.229.19.362.472.362.77s-.133.58-.362.77l-9.448,7.825c-.302.375-.163.773-.111.889.054.121.27.516.794.516h13.128c1.103,0,2-.897,2-2v-1c0-.552.447-1,1-1s1,.448,1,1v1c0,2.206-1.794,4-4,4Z"
            }
        ]
    },
    hourglass: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        raw: `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1035"
   xml:space="preserve"
   width="24"
   height="24"
   viewBox="0 0 32 36"
   style="margin-top:0.6em"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1039"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1049"><path
         d="M 0,24 H 24 V 0 H 0 Z"
         id="path1047" /></clipPath></defs><g
     id="g1041"
     transform="matrix(1.3333333,0,0,-1.3333333,0,32)"><g
       id="g1043"><g
         id="g1045"
         clip-path="url(#clipPath1049)"><g
           id="g1051"
           transform="translate(15,12)"><path
             d="M 0,0 C 2.004,-1.594 4.451,-4.146 4.968,-7.597 5.236,-9.393 3.811,-11 1.995,-11 l -9.99,10e-4 c -1.817,0 -3.242,1.609 -2.972,3.406 0.52,3.459 2.959,6.004 4.967,7.593 -2.008,1.589 -4.447,4.134 -4.967,7.593 -0.27,1.797 1.155,3.406 2.972,3.406 L 1.995,11 C 3.811,11 5.236,9.393 4.968,7.597 4.451,4.146 2.004,1.594 0,0 Z"
             style="fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1053" /></g></g></g></g></svg>
`
    },
    AlertTriangle: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        raw: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="display:block;margin:auto;">
  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <line x1="12" y1="9" x2="12" y2="13" stroke="#000000" stroke-width="2" stroke-linecap="round"/>
  <circle cx="12" cy="17" r="1" fill="#000000"/>
</svg>`
    },
    CloudCog: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m16.5,18c0-.46-.089-.895-.218-1.312l.55-.317c.479-.276.643-.887.367-1.366h0c-.276-.478-.887-.643-1.365-.367l-.544.314c-.605-.652-1.393-1.126-2.289-1.331v-.621c0-.552-.448-1-1-1h0c-.552,0-1,.448-1,1v.621c-.896.205-1.685.678-2.289,1.331l-.544-.314c-.478-.276-1.09-.111-1.365.367h0c-.276.479-.112,1.09.367,1.366l.55.317c-.129.418-.218.853-.218,1.312s.089.895.218,1.312l-.55.317c-.479.276-.643.887-.367,1.366h0c.276.478.887.643,1.365.367l.544-.314c.605.652,1.393,1.126,2.289,1.331v.621c0,.552.448,1,1,1h0c.552,0,1-.448,1-1v-.621c.896-.205,1.685-.678,2.289-1.331l.544.314c.478.276,1.09.111,1.365-.367h0c.276-.479.112-1.09-.367-1.366l-.55-.317c.129-.418.218-.853.218-1.312Zm-4.5,1.5c-.827,0-1.5-.673-1.5-1.5s.673-1.5,1.5-1.5,1.5.673,1.5,1.5-.673,1.5-1.5,1.5Zm12-7.003c0,2.909-1.668,5.431-4.095,6.674.056-.383.095-.772.095-1.171,0-4.418-3.582-8-8-8s-8,3.582-8,8c0,.634.082,1.248.221,1.84-2.417-.579-4.221-2.752-4.221-5.344,0-1.546.656-3.029,1.801-4.07.273-.248.405-.593.346-.901-.184-.946-.195-1.919-.033-2.89C2.66,3.346,5.225.734,8.497.134c3.592-.661,7.183,1.167,8.735,4.438.14.296.41.503.742.569,3.492.696,6.026,3.789,6.026,7.354Z",
                fill: "currentColor"
            }
        ]
    },
    Cloud2: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M1.2 15C1.2 17.98 3.62 20.4 6.6 20.4H18C20.65 20.4 22.8 18.25 22.8 15.6C22.8 13.67 21.66 12 20.01 11.24C20.26 10.75 20.4 10.19 20.4 9.6C20.4 7.61 18.79 6 16.8 6C16.14 6 15.52 6.18 14.99 6.49C14.08 4.77 12.28 3.6 10.2 3.6C7.22 3.6 4.8 6.02 4.8 9C4.8 9.3 4.83 9.6 4.87 9.88C2.74 10.6 1.2 12.62 1.2 15Z",
                fill: "currentColor"
            }
        ]
    },
    userStars: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M12,16c2.206,0,4-1.794,4-4s-1.794-4-4-4-4,1.794-4,4,1.794,4,4,4Zm0,1c-3.309,0-6,2.691-6,6,0,.553,.448,1,1,1h10c.552,0,1-.447,1-1,0-3.309-2.691-6-6-6Zm-6.199-7.481c.216,.589-.523,1.138-1.025,.763l-1.309-.912-1.305,.912c-.498,.374-1.232-.166-1.022-.753l.465-1.456-1.219-.849c-.537-.349-.254-1.261,.388-1.24h1.595l.371-1.421c.168-.738,1.294-.737,1.462,0l.371,1.421h1.585c.64-.021,.922,.885,.387,1.234l-1.221,.853,.476,1.447Zm17.907-2.3l-1.221,.853,.476,1.447c.216,.589-.523,1.138-1.025,.763l-1.309-.912-1.305,.912c-.498,.374-1.231-.167-1.022-.753l.465-1.456-1.219-.849c-.537-.349-.254-1.261,.388-1.24h1.595l.371-1.421c.168-.738,1.294-.737,1.462,0l.371,1.421h1.585c.64-.021,.922,.885,.387,1.234ZM8.648,2.515c.067-.308,.34-.53,.656-.529h1.595l.371-1.421c.168-.738,1.294-.737,1.462,0l.371,1.421h1.585c.64-.021,.922,.885,.387,1.234l-1.221,.853,.476,1.447c.216,.589-.524,1.138-1.025,.763l-1.309-.912-1.305,.912c-.498,.374-1.232-.166-1.022-.753l.465-1.456-1.219-.849c-.228-.159-.334-.441-.268-.71Z",
                fill: "currentColor"
            }
        ]
    },
    graduationCap: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m24 8.48v11.52a1 1 0 0 1 -2 0v-8.248l-7.4 3.536a5 5 0 0 1 -2.577.694 5.272 5.272 0 0 1 -2.7-.739l-7.38-3.513a3.691 3.691 0 0 1 -.084-6.455c.027-.016.056-.031.084-.045l7.457-3.558a5.226 5.226 0 0 1 5.282.045l7.375 3.513a3.767 3.767 0 0 1 1.943 3.25zm-11.978 9.5a7.26 7.26 0 0 1 -3.645-.972l-4.377-2.089v2.7a5.007 5.007 0 0 0 3.519 4.778 15.557 15.557 0 0 0 4.481.603 15.557 15.557 0 0 0 4.481-.607 5.007 5.007 0 0 0 3.519-4.778v-2.691l-4.459 2.13a6.983 6.983 0 0 1 -3.519.928z",
                fill: "currentColor"
            }
        ]
    },
    chef: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "m19,24H5c-.29,0-.565-.126-.755-.345s-.275-.51-.234-.797c.559-3.91,3.994-6.858,7.99-6.858s7.431,2.948,7.99,6.858c.041.287-.044.578-.234.797s-.465.345-.755.345ZM15,3L12.703.32c-.37-.431-1.037-.431-1.406,0l-2.297,2.68L7.397.341c-.418-.628-1.397-.331-1.397.423v5.236h12V.764c0-.754-.978-1.051-1.397-.423l-1.603,2.659Zm-9,5c0,3.309,2.691,6,6,6s6-2.691,6-6H6Z",
                fill: "currentColor"
            }
        ]
    },
    chef2: {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        paths: [
            {
                d: "M16,0H8C5.243,0,3,2.243,3,5v14c0,2.757,2.243,5,5,5h8c2.757,0,5-2.243,5-5V5c0-2.757-2.243-5-5-5Zm.5,12c-.334,0-.639-.113-.888-.297-.281,.577-.612,1.432-.612,2.297v1c0,.552-.448,1-1,1h-4c-.552,0-1-.448-1-1v-1c0-.864-.331-1.719-.612-2.297-.249,.184-.554,.297-.888,.297-.828,0-1.5-.672-1.5-1.5s.672-1.5,1.5-1.5,1.5,.672,1.5,1.5c0,.3-.09,.578-.242,.812.63,.306,1.483,.844,1.891,1.674,.265-1.078,.814-2.339,1.124-3.009-.72-.11-1.274-.726-1.274-1.477,0-.828,.672-1.5,1.5-1.5s1.5,.672,1.5,1.5c0,.751-.553,1.367-1.274,1.477,.31,.669,.859,1.931,1.124,3.009,.408-.83,1.261-1.369,1.891-1.674-.151-.234-.242-.512-.242-.812,0-.828,.672-1.5,1.5-1.5s1.5,.672,1.5,1.5-.672,1.5-1.5,1.5Z",
                fill: "currentColor"
            }
        ]
    }
};
